(function () {
  'use strict';

  function qs(sel, root) {
    return (root || document).querySelector(sel);
  }

  function qsa(sel, root) {
    return Array.prototype.slice.call((root || document).querySelectorAll(sel));
  }

  function fetchJSON(url, options) {
    return fetch(url, Object.assign({ credentials: 'same-origin', headers: { Accept: 'application/json', 'X-Requested-With': 'XMLHttpRequest' } }, options || {})).then(function (r) {
      if (!r.ok) throw new Error(r.statusText);
      return r.json();
    });
  }

  function getMoneyFormat() {
    if (window.__egMoneyFormat) return window.__egMoneyFormat;
    var body = document.body;
    if (body && body.getAttribute('data-money-format')) {
      window.__egMoneyFormat = body.getAttribute('data-money-format');
      return window.__egMoneyFormat;
    }
    if (window.theme && window.theme.moneyFormat) {
      window.__egMoneyFormat = window.theme.moneyFormat;
      return window.__egMoneyFormat;
    }
    if (typeof Shopify !== 'undefined' && Shopify.money_format) {
      window.__egMoneyFormat = Shopify.money_format;
      return window.__egMoneyFormat;
    }
    var pricingEl = qs('#eg-product-variant-pricing');
    if (pricingEl) {
      try {
        var pricing = JSON.parse(pricingEl.textContent);
        if (pricing && pricing.moneyFormat) {
          window.__egMoneyFormat = pricing.moneyFormat;
          return window.__egMoneyFormat;
        }
      } catch (e) {}
    }
    return '${{amount_with_comma_separator}}';
  }

  function formatMoneyWithFormat(cents, format) {
    if (typeof cents !== 'number' || isNaN(cents)) return '';
    var formatString = format || getMoneyFormat();
    var placeholderRegex = /\{\{\s*(\w+)\s*\}\}/;
    var match = formatString.match(placeholderRegex);
    if (!match) return formatMoney(cents);

    function formatWithDelimiters(number, precision, thousands, decimal) {
      thousands = thousands == null ? ',' : thousands;
      decimal = decimal == null ? '.' : decimal;
      var fixed = (number / 100).toFixed(precision);
      var parts = fixed.split('.');
      parts[0] = parts[0].replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1' + thousands);
      return parts[1] != null && precision > 0 ? parts[0] + decimal + parts[1] : parts[0];
    }

    var token = match[1];
    var value = '';
    if (token === 'amount') {
      value = formatWithDelimiters(cents, 2);
    } else if (token === 'amount_no_decimals') {
      value = formatWithDelimiters(cents, 0);
    } else if (token === 'amount_with_comma_separator') {
      value = formatWithDelimiters(cents, 2, ',', '.');
    } else if (token === 'amount_no_decimals_with_comma_separator') {
      value = formatWithDelimiters(cents, 0, ',', '.');
    } else if (token === 'amount_with_apostrophe_separator') {
      value = formatWithDelimiters(cents, 2, "'", '.');
    } else if (token === 'amount_with_space_separator') {
      value = formatWithDelimiters(cents, 2, ' ', ',');
    } else if (token === 'amount_no_decimals_with_space_separator') {
      value = formatWithDelimiters(cents, 0, ' ', ',');
    } else {
      value = formatWithDelimiters(cents, 2, ',', '.');
    }

    return formatString.replace(placeholderRegex, value);
  }

  function formatMoney(cents) {
    return formatMoneyWithFormat(cents, getMoneyFormat());
  }

  var CART_SECTION_FILE = 'ptp-cart-drawer';

  function getSectionRenderUrl(sectionFile) {
    var root = (document.body && document.body.getAttribute('data-shop-root')) || '/';
    if (root === '/') return '/?sections=' + encodeURIComponent(sectionFile);
    return root.replace(/\/+$/, '') + '/?sections=' + encodeURIComponent(sectionFile);
  }

  function debounce(fn, wait) {
    var timer;
    return function () {
      var ctx = this;
      var args = arguments;
      window.clearTimeout(timer);
      timer = window.setTimeout(function () {
        fn.apply(ctx, args);
      }, wait);
    };
  }

  function setCartBadge(count) {
    var n = typeof count === 'number' && !isNaN(count) ? count : 0;
    var el = qs('[data-eg-cart-count]');
    if (el) {
      el.textContent = n > 0 ? String(n) : '';
      el.hidden = n === 0;
    }
    var label = qs('[data-eg-cart-label]');
    if (label) {
      var tpl = label.getAttribute(n === 1 ? 'data-label-one' : 'data-label-other');
      if (tpl) label.textContent = tpl.replace('[n]', String(n));
    }
  }

  function getCartDrawerRoot() {
    var drawer = qs('[data-eg-cart-drawer]');
    if (!drawer) return null;
    return qs('.eg-cart-drawer__panel', drawer) || drawer;
  }

  function getCartPageRoot() {
    return qs('[data-eg-cart-page]');
  }

  /**
   * Liquid renders the minus button disabled at quantity 1, but two paths change
   * the quantity without re-rendering that button: the drawer's fine-grained
   * patch, and the optimistic local bump before the debounced request fires.
   * This is the single owner of the rule.
   */
  function syncCartQtyButtons(root) {
    if (!root) return;
    qsa('[data-eg-qty]', root).forEach(function (container) {
      var input = qs('[data-eg-cart-change]', container);
      var minus = qs('[data-eg-qty-minus]', container);
      if (!input || !minus) return;
      var qty = parseInt(input.value, 10);
      minus.disabled = !isNaN(qty) && qty <= 1;
    });
  }

  function setCartLoading(getRoot, on, line) {
    var root = getRoot();
    if (!root) return;
    root.setAttribute('aria-busy', on ? 'true' : 'false');
    qsa('[data-eg-line-price].is-updating', root).forEach(function (el) {
      el.classList.remove('is-updating');
      el.removeAttribute('aria-busy');
    });
    if (on) {
      var price = qs('[data-eg-cart-line="' + Number(line) + '"] [data-eg-line-price]', root);
      if (price) {
        price.classList.add('is-updating');
        price.setAttribute('aria-busy', 'true');
      }
    }
    // Disable cart controls while a request is in flight so no second action
    // (qty change, remove, checkout) can start before this one finishes. Setting
    // `disabled` blocks keyboard and spinner input, which pointer-events alone does not.
    qsa(
      '[data-eg-cart-change], [data-eg-qty-minus], [data-eg-qty-plus], [data-eg-cart-remove], [data-eg-coupon-input], [data-eg-coupon-apply], [name="checkout"], [name="update"]',
      root
    ).forEach(function (el) {
      el.disabled = !!on;
    });
    // Unlocking is a blanket re-enable, so the quantity rule has to be reapplied.
    if (!on) syncCartQtyButtons(root);
  }

  // Persistent polite live region so screen readers hear cart updates. Lives on
  // <body> (not inside the drawer) so it survives the drawer's innerHTML refresh.
  function announceCart(message) {
    var region = qs('#eg-cart-live');
    if (!region) {
      region = document.createElement('div');
      region.id = 'eg-cart-live';
      region.className = 'eg-visually-hidden';
      region.setAttribute('role', 'status');
      region.setAttribute('aria-live', 'polite');
      document.body.appendChild(region);
    }
    region.textContent = '';
    window.setTimeout(function () {
      region.textContent = message;
    }, 60);
  }

  function showCartError(surface, on) {
    var root = surface.getRoot();
    var el = root && qs('[data-eg-cart-error]', root);
    if (el) el.hidden = !on;
  }

  function commitStartingStyle(el) {
    if (el) void el.offsetWidth;
  }

  var cartToastTimer = null;

  function getCartDeletedMessage() {
    var msg = document.body && document.body.getAttribute('data-cart-deleted-message');
    return msg || 'Item removed from cart.';
  }

  function showCartToast() {
    var toast = qs('[data-eg-cart-toast]');
    if (!toast) return;
    window.clearTimeout(cartToastTimer);
    toast.hidden = false;
    commitStartingStyle(toast);
    toast.classList.add('is-visible');
    cartToastTimer = window.setTimeout(function () {
      toast.classList.remove('is-visible');
      cartToastTimer = window.setTimeout(function () {
        toast.hidden = true;
      }, 200);
    }, 2600);
  }

  // Record which control had focus before a re-render so it can be restored after
  // the drawer's innerHTML is swapped (otherwise focus falls to <body>).
  function captureCartFocus(drawer) {
    var active = document.activeElement;
    if (!drawer || !active || !drawer.contains(active)) return null;
    if (active.hasAttribute('data-eg-close-cart')) return { role: 'close', line: null };
    if (active.hasAttribute('data-eg-cart-remove')) {
      return { role: 'remove', line: active.getAttribute('data-eg-cart-remove') };
    }
    var role = null;
    if (active.hasAttribute('data-eg-qty-plus')) role = 'plus';
    else if (active.hasAttribute('data-eg-qty-minus')) role = 'minus';
    else if (active.hasAttribute('data-eg-cart-change')) role = 'input';
    else return null;
    var container = active.closest('[data-eg-qty]');
    var input = container ? qs('[data-eg-cart-change]', container) : null;
    var line = input ? input.getAttribute('data-line') : active.getAttribute('data-line');
    return line ? { role: role, line: line } : null;
  }

  function restoreCartFocus(root, desc, fallbackSelector) {
    if (!root || !desc || !desc.role) return;
    // Only reclaim focus if the re-render lost it from the drawer.
    if (root.contains(document.activeElement) && document.activeElement !== document.body) return;
    var target = null;
    if (desc.role === 'close') {
      target = qs('[data-eg-close-cart]', root);
    } else if (desc.role === 'remove') {
      target = qs('[data-eg-cart-remove="' + desc.line + '"]', root);
    } else {
      var input = qs('[data-eg-cart-change][data-line="' + desc.line + '"]', root);
      var container = input ? input.closest('[data-eg-qty]') : null;
      if (desc.role === 'plus') target = container ? qs('[data-eg-qty-plus]', container) : null;
      else if (desc.role === 'minus') target = container ? qs('[data-eg-qty-minus]', container) : null;
      else target = input;
      // Stepping down to 1 disables the minus button that had focus; a disabled
      // element can't take focus, so keep it on the quantity field instead.
      if (target && target.disabled) target = input;
    }
    // Line gone (e.g. removed) → fall back to the close button so focus stays in the drawer.
    if (!target) target = qs(fallbackSelector, root);
    if (target && target.focus) target.focus();
  }

  function refreshCartBadge() {
    fetchJSON('/cart.js')
      .then(function (cart) {
        setCartBadge(cart.item_count);
      })
      .catch(function () {});
  }

  var lastCartOpener = null;
  var cartBusy = false;

  function getCartFocusable(container) {
    if (!container) return [];
    return qsa(
      'a[href], button:not([disabled]), input:not([disabled]), [tabindex]:not([tabindex="-1"])',
      container
    ).filter(function (el) {
      return el.offsetWidth > 0 || el.offsetHeight > 0 || el === document.activeElement;
    });
  }

  // Keep Tab focus inside the open drawer (WCAG modal dialog pattern).
  function trapCartFocus(e) {
    if (e.key !== 'Tab') return;
    var drawer = qs('[data-eg-cart-drawer]');
    if (!drawer || !drawer.classList.contains('is-open')) return;
    var panel = qs('.eg-cart-drawer__panel', drawer) || drawer;
    var focusable = getCartFocusable(panel);
    if (!focusable.length) return;
    var first = focusable[0];
    var last = focusable[focusable.length - 1];
    if (!panel.contains(document.activeElement)) {
      e.preventDefault();
      first.focus();
      return;
    }
    if (e.shiftKey && document.activeElement === first) {
      e.preventDefault();
      last.focus();
    } else if (!e.shiftKey && document.activeElement === last) {
      e.preventDefault();
      first.focus();
    }
  }

  function openCartDrawer(opener) {
    var drawer = qs('[data-eg-cart-drawer]');
    if (!drawer) return;
    var err = qs('[data-eg-cart-error]', drawer);
    if (err) err.hidden = true;
    var wasOpen = drawer.classList.contains('is-open');
    if (!wasOpen) commitStartingStyle(qs('.eg-cart-drawer__panel', drawer));
    drawer.classList.add('is-open');
    drawer.setAttribute('aria-hidden', 'false');
    document.documentElement.classList.add('eg-cart-open');
    document.addEventListener('keydown', trapCartFocus, true);
    if (wasOpen) return;
    lastCartOpener = opener || document.activeElement;
    var focusTarget = qs('[data-eg-close-cart]', drawer) || qs('.eg-cart-drawer__panel', drawer);
    if (focusTarget && focusTarget.focus) focusTarget.focus();
  }

  function closeCartDrawer() {
    var drawer = qs('[data-eg-cart-drawer]');
    if (!drawer) return;
    drawer.classList.remove('is-open');
    drawer.setAttribute('aria-hidden', 'true');
    document.documentElement.classList.remove('eg-cart-open');
    document.removeEventListener('keydown', trapCartFocus, true);
    if (lastCartOpener && lastCartOpener.focus) lastCartOpener.focus();
    lastCartOpener = null;
  }

  /** Close button + backdrop — must run after innerHTML refresh replaces those nodes. */
  function bindCartDrawerChrome(drawer) {
    if (!drawer) return;
    qsa('[data-eg-close-cart]', drawer).forEach(function (btn) {
      btn.addEventListener('click', function (e) {
        e.preventDefault();
        closeCartDrawer();
      });
    });
    var backdrop = qs('[data-eg-cart-backdrop]', drawer);
    if (backdrop) {
      backdrop.addEventListener('click', closeCartDrawer);
    }
  }

  // The drawer and the cart page are two views of one cart, so they share every
  // control, every handler and one request. A surface only describes what differs:
  // where its markup lives, how to re-render it, and where focus lands on re-render.
  var CART_SURFACES = {
    drawer: {
      getRoot: getCartDrawerRoot,
      getSectionId: function () {
        return qs('[data-eg-cart-drawer]') ? CART_SECTION_FILE : '';
      },
      getSectionUrl: function () {
        return getSectionRenderUrl(CART_SECTION_FILE);
      },
      apply: applyCartDrawerHtml,
      focusFallback: '[data-eg-close-cart]',
      afterRemove: showCartToast,
    },
    page: {
      getRoot: getCartPageRoot,
      getSectionId: getCartPageSectionId,
      getSectionUrl: function () {
        return window.location.pathname + '?sections=' + encodeURIComponent(getCartPageSectionId());
      },
      apply: applyCartPageHtml,
      focusFallback: '[name="checkout"], .eg-cart-empty .eg-btn',
      afterRemove: null,
    },
  };

  function cartSurfaceList() {
    return Object.keys(CART_SURFACES).map(function (key) {
      return CART_SURFACES[key];
    });
  }

  function presentCartSurfaces() {
    return cartSurfaceList().filter(function (surface) {
      return !!surface.getSectionId() && !!surface.getRoot();
    });
  }

  function bindCartSurface(surface) {
    var root = surface.getRoot();
    if (!root) return;

    qsa('[data-eg-cart-coupon]', root).forEach(function (wrap) {
      var input = qs('[data-eg-coupon-input]', wrap);
      var btn = qs('[data-eg-coupon-apply]', wrap);
      if (!input || !btn) return;
      btn.addEventListener('click', function () {
        applyCartCoupon(surface, input.value);
      });
      input.addEventListener('keydown', function (e) {
        if (e.key !== 'Enter') return;
        // The cart page's field sits inside the cart form; Enter would submit it.
        e.preventDefault();
        applyCartCoupon(surface, input.value);
      });
    });

    qsa('[data-eg-cart-note]', root).forEach(function (note) {
      note.addEventListener('input', function () {
        onCartNoteChange(note);
      });
      // Blur commits immediately, so leaving the field can't lose the note.
      note.addEventListener('change', function () {
        saveCartNote(note);
      });
    });

    qsa('[data-eg-cart-change]', root).forEach(function (input) {
      input.addEventListener('input', function () {
        if (!cartBusy) syncCartQtyButtons(root);
      });
      input.addEventListener('change', function () {
        onCartQtyChange(surface, input);
      });
      // Enter inside the cart page's form would submit it and reload; apply instead.
      input.addEventListener('keydown', function (e) {
        if (e.key !== 'Enter') return;
        e.preventDefault();
        applyCartQty(surface, input);
      });
    });

    qsa('[data-eg-qty-minus], [data-eg-qty-plus]', root).forEach(function (btn) {
      btn.addEventListener('click', function () {
        if (cartBusy) return;
        var container = btn.closest('[data-eg-qty]');
        var input = container && qs('[data-eg-cart-change]', container);
        if (!input) return;
        var current = parseInt(input.value, 10);
        if (isNaN(current)) current = 1;
        var next = btn.hasAttribute('data-eg-qty-plus') ? current + 1 : current - 1;
        if (next < 1) next = 1; // floor at 1; use Remove to delete a line
        if (next === current) return;
        var hadFocus = document.activeElement === btn;
        input.value = next;
        syncCartQtyButtons(root);
        // Disabling a focused button blurs it to <body> right now, long before the
        // debounced request captures focus, so hand it to the field synchronously.
        if (hadFocus && btn.disabled) input.focus();
        onCartQtyChange(surface, input);
      });
    });

    qsa('[data-eg-cart-remove]', root).forEach(function (btn) {
      btn.addEventListener('click', function (e) {
        e.preventDefault();
        var line = btn.getAttribute('data-eg-cart-remove');
        if (!line) return;
        changeCartLine(surface, line, 0);
      });
    });
  }

  function applyCartQty(surface, input) {
    var line = input.getAttribute('data-line');
    if (!line) return;
    var qty = parseInt(input.value, 10);
    if (isNaN(qty) || qty < 0) {
      input.value = input.defaultValue || '1';
      return;
    }
    changeCartLine(surface, line, qty);
  }

  var onCartQtyChange = debounce(applyCartQty, 600);

  // The note is saved on its own, not through /cart/change.js, so a re-render of
  // the section always brings back what the shopper typed.
  function saveCartNote(note) {
    fetch('/cart/update.js', {
      method: 'POST',
      credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ note: note.value }),
    }).catch(function () {});
  }

  var onCartNoteChange = debounce(saveCartNote, 600);

  function setCouponStatus(surface, message, ok) {
    var root = surface.getRoot();
    var el = root && qs('[data-eg-coupon-status]', root);
    if (!el) return;
    el.textContent = message || '';
    el.hidden = !message;
    el.classList.toggle('is-error', !!message && !ok);
    el.classList.toggle('is-success', !!message && !!ok);
  }

  /**
   * Discount codes have no dedicated cart API: /cart/update.js takes a `discount`
   * key holding the full comma-separated list, so applying one means sending the
   * whole set. With multiples off the new code replaces the old, which is also
   * what lets a shopper recover from a typo without a remove control.
   *
   * Shopify answers 200 for an unknown code and reports it as applicable: false,
   * so success has to be read off the returned discount_codes rather than status.
   */
  function applyCartCoupon(surface, raw) {
    if (cartBusy) return;
    var root = surface.getRoot();
    var wrap = root && qs('[data-eg-cart-coupon]', root);
    if (!wrap) return;
    var code = String(raw || '')
      .split(',')[0]
      .trim()
      .toUpperCase();
    if (!code) return;

    var msg = function (key) {
      return wrap.getAttribute('data-msg-' + key) || '';
    };
    var allowMultiple = wrap.getAttribute('data-allow-multiple') === 'true';
    var targets = presentCartSurfaces();
    if (!targets.length) return;

    cartBusy = true;
    setCouponStatus(surface, '', true);
    targets.forEach(function (s) {
      setCartLoading(s.getRoot, true, null);
    });

    fetchJSON('/cart.js')
      .then(function (cart) {
        var existing = cart.discount_codes || [];
        var already = existing.some(function (d) {
          return String(d.code).toUpperCase() === code;
        });
        if (already) return { status: 'applied' };

        var codes = allowMultiple
          ? [code].concat(
              existing.map(function (d) {
                return d.code;
              })
            )
          : [code];

        return fetch('/cart/update.js', {
          method: 'POST',
          credentials: 'same-origin',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({
            discount: codes.join(','),
            sections: targets
              .map(function (s) {
                return s.getSectionId();
              })
              .join(','),
            sections_url: window.location.pathname,
          }),
        })
          .then(function (r) {
            if (!r.ok) throw new Error();
            return r.json();
          })
          .then(function (updated) {
            setCartBadge(updated.item_count);
            var sections = updated.sections || {};
            targets.forEach(function (s) {
              var html = sections[s.getSectionId()];
              if (html) s.apply(html);
            });
            var accepted = (updated.discount_codes || []).some(function (d) {
              return String(d.code).toUpperCase() === code && d.applicable;
            });
            return { status: accepted ? 'success' : 'invalid' };
          });
      })
      .catch(function () {
        return { status: 'error' };
      })
      .then(function (result) {
        setCouponStatus(surface, msg(result.status), result.status === 'success');
        var fresh = qs('[data-eg-coupon-input]', surface.getRoot());
        if (!fresh) return;
        // Keep a rejected code on screen so it can be corrected; clear on success.
        if (result.status === 'success') fresh.value = '';
        else fresh.value = code;
      })
      .finally(function () {
        cartBusy = false;
        targets.forEach(function (s) {
          setCartLoading(s.getRoot, false);
        });
      });
  }

  function refreshCartSurface(surface) {
    var sectionId = surface.getSectionId();
    if (!sectionId) return Promise.resolve();
    return fetch(surface.getSectionUrl())
      .then(function (r) {
        if (!r.ok) throw new Error();
        return r.json();
      })
      .then(function (json) {
        surface.apply(json[sectionId]);
      });
  }

  // Single round-trip: /cart/change.js returns the updated cart plus re-rendered
  // markup for every surface on the page, so a qty change never chains fetches and
  // the drawer and cart page can't disagree about what's in the cart.
  function changeCartLine(surface, line, qty) {
    if (!line || cartBusy) return;
    var targets = presentCartSurfaces();
    if (!surface.getSectionId() || !targets.length) return;
    cartBusy = true;
    // Capture focus before setCartLoading disables (and blurs) the active control.
    var focusDesc = captureCartFocus(surface.getRoot());
    targets.forEach(function (s) {
      showCartError(s, false);
      setCartLoading(s.getRoot, true, s === surface ? line : null);
    });
    fetch('/cart/change.js', {
      method: 'POST',
      credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({
        line: Number(line),
        quantity: qty,
        sections: targets
          .map(function (s) {
            return s.getSectionId();
          })
          .join(','),
        sections_url: window.location.pathname,
      }),
    })
      .then(function (r) {
        if (!r.ok) throw new Error();
        return r.json();
      })
      .then(function (cart) {
        setCartBadge(cart.item_count);
        announceCart(
          qty === 0
            ? getCartDeletedMessage()
            : 'Cart updated. Subtotal ' + formatMoney(cart.total_price)
        );
        var sections = cart.sections || {};
        // Fallback if the combined response omits a section's markup.
        var pending = targets.map(function (s) {
          var html = sections[s.getSectionId()];
          if (!html) return refreshCartSurface(s);
          s.apply(html);
          return Promise.resolve();
        });
        return Promise.all(pending).then(function () {
          if (qty === 0 && surface.afterRemove) surface.afterRemove();
        });
      })
      .catch(function () {
        // No full-page reload: restore server state, keep the drawer open, show an inline error.
        return refreshCartSurface(surface)
          .catch(function () {})
          .then(function () {
            showCartError(surface, true);
          });
      })
      .finally(function () {
        cartBusy = false;
        targets.forEach(function (s) {
          setCartLoading(s.getRoot, false);
        });
        restoreCartFocus(surface.getRoot(), focusDesc, surface.focusFallback);
      });
  }

  function syncCartHtml(live, next) {
    if (!live || !next) return;
    if (live.innerHTML !== next.innerHTML) live.innerHTML = next.innerHTML;
  }

  function patchCartDrawerLines(drawer, newDrawer) {
    var liveLines = qsa('[data-eg-cart-line-key]', drawer);
    var nextLines = qsa('[data-eg-cart-line-key]', newDrawer);
    if (!liveLines.length || liveLines.length !== nextLines.length) return false;

    // A threshold-based cart discount can appear or disappear on a quantity change,
    // and it lives in the footer rather than a line, so fall back to a full swap.
    if (!qs('.eg-cart-discounts', drawer) !== !qs('.eg-cart-discounts', newDrawer)) return false;

    var i;
    for (i = 0; i < liveLines.length; i++) {
      if (
        liveLines[i].getAttribute('data-eg-cart-line-key') !==
        nextLines[i].getAttribute('data-eg-cart-line-key')
      ) {
        return false;
      }
      if (
        !qs('.eg-cart-line__discounts', liveLines[i]) !==
        !qs('.eg-cart-line__discounts', nextLines[i])
      ) {
        return false;
      }
    }

    for (i = 0; i < liveLines.length; i++) {
      syncCartHtml(
        qs('[data-eg-line-price]', liveLines[i]),
        qs('[data-eg-line-price]', nextLines[i])
      );
      syncCartHtml(
        qs('.eg-cart-line__discounts', liveLines[i]),
        qs('.eg-cart-line__discounts', nextLines[i])
      );
      var liveQty = qs('[data-eg-cart-change]', liveLines[i]);
      var nextQty = qs('[data-eg-cart-change]', nextLines[i]);
      if (liveQty && nextQty) {
        liveQty.defaultValue = nextQty.value;
        if (liveQty.value !== nextQty.value) liveQty.value = nextQty.value;
      }
    }

    syncCartHtml(qs('.eg-cart-drawer__title', drawer), qs('.eg-cart-drawer__title', newDrawer));
    syncCartHtml(
      qs('.eg-cart-drawer__subtotal', drawer),
      qs('.eg-cart-drawer__subtotal', newDrawer)
    );
    // A percentage discount's amount moves with the subtotal even when it stays applied.
    syncCartHtml(qs('.eg-cart-discounts', drawer), qs('.eg-cart-discounts', newDrawer));

    var err = qs('[data-eg-cart-error]', drawer);
    if (err) err.hidden = true;
    announceCartUpdate();
    return true;
  }

  /**
   * Cart drawer updates in place, so screen readers need the new count and total spoken.
   * The status node lives in the layout, not the drawer, so it survives the drawer's innerHTML swap.
   */
  function announceCartUpdate() {
    var drawer = qs('[data-eg-cart-drawer]');
    if (!drawer) return;
    var status = qs('[data-eg-cart-status]');
    if (!status) return;
    var title = qs('.eg-cart-drawer__title', drawer);
    var subtotal = qs('.eg-cart-drawer__subtotal', drawer);
    var parts = [];
    if (title) parts.push(title.textContent.replace(/\s+/g, ' ').trim());
    if (subtotal) parts.push(subtotal.textContent.replace(/\s+/g, ' ').trim());
    status.textContent = parts.join('. ');
  }

  /** Swap the drawer's inner markup with freshly rendered section HTML, preserving open state. */
  function applyCartDrawerHtml(html) {
    var drawer = qs('[data-eg-cart-drawer]');
    if (!drawer || !html) return;
    var wrap = document.createElement('div');
    wrap.innerHTML = html;
    var newDrawer = wrap.querySelector('[data-eg-cart-drawer]');
    if (!newDrawer) return;
    if (patchCartDrawerLines(drawer, newDrawer)) return;
    var wasOpen = drawer.classList.contains('is-open');
    var items = qs('.eg-cart-drawer__items', drawer);
    var scrollTop = items ? items.scrollTop : 0;
    drawer.innerHTML = newDrawer.innerHTML;
    drawer.className = newDrawer.className;
    if (wasOpen) {
      drawer.classList.add('is-open');
      drawer.setAttribute('aria-hidden', 'false');
      document.documentElement.classList.add('eg-cart-open');
    } else {
      var ah = newDrawer.getAttribute('aria-hidden');
      if (ah != null) drawer.setAttribute('aria-hidden', ah);
    }
    if (scrollTop) {
      var newItems = qs('.eg-cart-drawer__items', drawer);
      if (newItems) newItems.scrollTop = scrollTop;
    }
    bindCartDrawerChrome(drawer);
    bindCartSurface(CART_SURFACES.drawer);
    announceCartUpdate();
  }

  function getCartPageSectionId() {
    var page = getCartPageRoot();
    return (page && page.getAttribute('data-eg-cart-page-section')) || '';
  }

  // A quantity change re-renders the whole section, which would throw away a note
  // the shopper is still typing (its debounced save may not have fired yet).
  // Carry the live value, focus and caret across the swap; this page is the only
  // writer of the note, so the local value always wins over the rendered one.
  function captureCartNote(page) {
    var note = qs('[data-eg-cart-note]', page);
    if (!note) return null;
    return {
      value: note.value,
      focused: document.activeElement === note,
      start: note.selectionStart,
      end: note.selectionEnd,
    };
  }

  function restoreCartNote(page, state) {
    if (!state) return;
    var note = qs('[data-eg-cart-note]', page);
    if (!note) return;
    if (note.value !== state.value) note.value = state.value;
    if (!state.focused) return;
    note.focus();
    try {
      note.setSelectionRange(state.start, state.end);
    } catch (e) {}
  }

  function applyCartPageHtml(html) {
    var page = getCartPageRoot();
    if (!page || !html) return;
    var wrap = document.createElement('div');
    wrap.innerHTML = html;
    var next = wrap.querySelector('[data-eg-cart-page]');
    if (!next) return;
    var noteState = captureCartNote(page);
    page.innerHTML = next.innerHTML;
    restoreCartNote(page, noteState);
    bindCartSurface(CART_SURFACES.page);
  }

  function initCartPage() {
    bindCartSurface(CART_SURFACES.page);
  }

  function initCartDrawer() {
    var drawer = qs('[data-eg-cart-drawer]');
    if (!drawer) return;

    var openBtns = qsa('[data-eg-open-cart]');

    openBtns.forEach(function (btn) {
      btn.addEventListener('click', function (e) {
        e.preventDefault();
        openCartDrawer(btn);
      });
    });

    bindCartDrawerChrome(drawer);

    document.addEventListener('keydown', function (e) {
      if (e.key !== 'Escape') return;
      // Prefer closing an open product dialog over the cart drawer.
      if (document.querySelector('dialog.eg-dialog[open], dialog.eg-drawing-dialog[open]')) return;
      closeCartDrawer();
    });

    bindCartSurface(CART_SURFACES.drawer);
  }

  function stripProductSubmitIcons() {
    qsa('.eg-product-form__submit-icon').forEach(function (el) {
      if (el.remove) el.remove();
    });
  }

  // Shared by the document-level quick-add and the recently-viewed outlet listener,
  // so mini-card buttons show the same spinner state as the collection card's form.
  function runQuickAdd(btn) {
    var vid = btn.getAttribute('data-variant-id');
    if (!vid) return;
    btn.disabled = true;
    btn.classList.add('is-loading');
    btn.setAttribute('aria-busy', 'true');
    fetch('/cart/add.js', {
      method: 'POST',
      credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ items: [{ id: Number(vid, 10), quantity: 1 }] }),
    })
      .then(function (r) {
        return r.json().then(function (body) {
          if (!r.ok) throw new Error();
          return body;
        });
      })
      .then(function () {
        refreshCartBadge();
        return refreshCartSurface(CART_SURFACES.drawer);
      })
      .then(function () {
        openCartDrawer();
      })
      .catch(function () {})
      .finally(function () {
        btn.disabled = false;
        btn.classList.remove('is-loading');
        btn.removeAttribute('aria-busy');
      });
  }

  function initAjaxAddToCart() {
    if (initAjaxAddToCart.__delegated) return;
    initAjaxAddToCart.__delegated = true;

    // Global quick-add for server-rendered cards (e.g. related products).
    // Recently-viewed binds its own outlet listener and calls stopPropagation,
    // so those clicks never reach this document-level handler (no double add).
    document.addEventListener('click', function (e) {
      var btn = e.target.closest ? e.target.closest('[data-eg-quick-add]') : null;
      if (!btn || btn.disabled) return;
      e.preventDefault();
      runQuickAdd(btn);
    });

    document.addEventListener('submit', function (e) {
      var form = e.target;
      if (!form || !form.classList || !form.classList.contains('eg-product-form')) return;
      e.preventDefault();
      var submitBtn = form.querySelector('[type="submit"][name="add"]');
      if (submitBtn && submitBtn.disabled) return;
      var fd = new FormData(form);
      var id = fd.get('id');
      var qty = parseInt(String(fd.get('quantity') || '1'), 10);
      if (!id || !qty || qty < 1) return;
      var labelEl = form.querySelector('.eg-product-form__submit-label');
      var wrap = form.closest('.eg-product-wrap');
      var addedMsg =
        (wrap && wrap.getAttribute('data-added-msg')) ||
        form.getAttribute('data-added-msg') ||
        'Added!';
      var errMsg =
        (wrap && wrap.getAttribute('data-add-error-msg')) ||
        form.getAttribute('data-add-error-msg') ||
        'Could not add to cart.';
      // Remember the idle label once, so re-clicking during the "Added!" window
      // doesn't capture "Added!" as the text to restore.
      if (labelEl && labelEl.getAttribute('data-eg-idle-label') === null) {
        labelEl.setAttribute('data-eg-idle-label', labelEl.textContent);
      }
      var prev = labelEl ? labelEl.getAttribute('data-eg-idle-label') : '';
      if (labelEl && labelEl.__egResetTimer) {
        window.clearTimeout(labelEl.__egResetTimer);
        labelEl.__egResetTimer = null;
      }
      if (submitBtn) {
        submitBtn.disabled = true;
        submitBtn.classList.add('is-loading');
        submitBtn.setAttribute('aria-busy', 'true');
      }
      fetch('/cart/add.js', {
        method: 'POST',
        credentials: 'same-origin',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ items: [{ id: Number(id, 10), quantity: qty }] }),
      })
        .then(function (r) {
          return r.json().then(function (body) {
            if (!r.ok) throw new Error(body.description || body.message || 'Cart error');
            return body;
          });
        })
        .then(function () {
          refreshCartBadge();
          return refreshCartSurface(CART_SURFACES.drawer);
        })
        .then(function () {
          openCartDrawer();
          if (labelEl) {
            labelEl.textContent = addedMsg;
            labelEl.__egResetTimer = window.setTimeout(function () {
              labelEl.textContent = prev;
              labelEl.__egResetTimer = null;
            }, 2000);
          }
        })
        .catch(function () {
          window.alert(errMsg);
        })
        .finally(function () {
          if (submitBtn) {
            submitBtn.disabled = false;
            submitBtn.classList.remove('is-loading');
            submitBtn.removeAttribute('aria-busy');
          }
        });
    });
  }

  var egProductGallery = null;

  function initProductGallery() {
    var gallery = qs('[data-eg-product-gallery]');
    if (!gallery) return;
    var mainEl = qs('.eg-gallery-main', gallery);
    if (!mainEl) return;

    var slideEls = qsa('.eg-gallery__slide', mainEl);
    var mediaIds = (gallery.getAttribute('data-eg-gallery-media-ids') || '')
      .split(',')
      .map(function (id) {
        return id.trim();
      })
      .filter(Boolean);
    var initialSlide = parseInt(gallery.getAttribute('data-eg-gallery-initial-slide') || '0', 10);
    if (isNaN(initialSlide) || initialSlide < 0) initialSlide = 0;
    if (initialSlide >= mediaIds.length) initialSlide = 0;

    var zoomType = gallery.getAttribute('data-eg-zoom-type') || 'none';
    var mainSwiper = null;

    // Single-image PDPs: skip Swiper. A locked one-slide Swiper swallows clicks and
    // can leave slides/activeIndex unusable, which breaks lightbox zoom.
    if (slideEls.length <= 1) {
      if (slideEls[0]) slideEls[0].classList.add('swiper-slide-active');
      mainSwiper = {
        slides: slideEls,
        activeIndex: 0,
        on: function () {},
        slideTo: function () {},
      };
      if (zoomType !== 'none') {
        initGalleryZoom(gallery, mainSwiper, zoomType);
      }
      egProductGallery = {
        setActiveMedia: function () {},
        mainSwiper: mainSwiper,
      };
      return;
    }

    if (typeof Swiper === 'undefined') return;

    var thumbsEl = qs('.eg-gallery-thumbs', gallery);
    var thumbsSwiper = null;
    var mainSwiper = null;

    if (typeof Swiper !== 'undefined') {
      if (thumbsEl) {
        thumbsSwiper = new Swiper(thumbsEl, {
          spaceBetween: 12,
          slidesPerView: 'auto',
          freeMode: true,
          watchSlidesProgress: true,
          a11y: false,
        });
      }

      var prevEl = qs('[data-eg-gallery-prev]', gallery);
      var nextEl = qs('[data-eg-gallery-next]', gallery);

      var mainOptions = {
        initialSlide: initialSlide,
        spaceBetween: 0,
        slidesPerView: 1,
        speed: 300,
        resistanceRatio: 0.85,
      };
      if (thumbsSwiper) mainOptions.thumbs = { swiper: thumbsSwiper };
      if (prevEl && nextEl) mainOptions.navigation = { prevEl: prevEl, nextEl: nextEl };

      mainSwiper = new Swiper(mainEl, mainOptions);
    }

    if (zoomType !== 'none') {
      initGalleryZoom(gallery, mainSwiper, zoomType);
    }

    // Thumbnail keyboard navigation (roving tabindex). Click and Enter/Space are
    // already handled by Swiper's thumbs module; this adds Arrow/Home/End traversal
    // of the strip, activating each thumb in the main image as focus moves.
    if (thumbsEl && mainSwiper) {
      var thumbButtons = qsa('.eg-gallery__thumb-slide', thumbsEl);

      var setThumbTabindex = function (activeIndex) {
        thumbButtons.forEach(function (btn, i) {
          btn.setAttribute('tabindex', i === activeIndex ? '0' : '-1');
        });
      };

      setThumbTabindex(mainSwiper.activeIndex);

      thumbButtons.forEach(function (btn, index) {
        btn.addEventListener('keydown', function (e) {
          var last = thumbButtons.length - 1;
          var target;
          switch (e.key) {
            case 'ArrowRight':
            case 'ArrowDown':
              target = index === last ? 0 : index + 1;
              break;
            case 'ArrowLeft':
            case 'ArrowUp':
              target = index === 0 ? last : index - 1;
              break;
            case 'Home':
              target = 0;
              break;
            case 'End':
              target = last;
              break;
            default:
              return;
          }
          e.preventDefault();
          setThumbTabindex(target);
          thumbButtons[target].focus();
          mainSwiper.slideTo(target);
        });
      });

      // Keep the tabbable thumb in sync when the main image changes by any means
      // (arrows, swipe, variant switch), so Tab returns focus to the active thumb.
      mainSwiper.on('slideChange', function () {
        setThumbTabindex(mainSwiper.activeIndex);
      });
    }

    function mediaIndex(mediaId) {
      return mediaIds.indexOf(String(mediaId));
    }

    function setActiveMedia(mediaId) {
      if (!mainSwiper) return;
      var idx = mediaIndex(mediaId);
      if (idx >= 0) mainSwiper.slideTo(idx);
    }

    egProductGallery = {
      setActiveMedia: setActiveMedia,
      mainSwiper: mainSwiper,
    };
  }

  function initGalleryZoom(gallery, mainSwiper, zoomType) {
    var frame = qs('.eg-gallery-main', gallery);
    if (!frame) return;

    var wantsHover = zoomType === 'zoom_hover' || zoomType === 'lightbox_zoom_hover';
    var wantsLightbox = zoomType === 'lightbox' || zoomType === 'lightbox_zoom_hover';

    function activeSlide() {
      if (!mainSwiper) return qs('.eg-gallery__slide', frame);
      var slides = mainSwiper.slides;
      if (!slides || !slides.length) return null;
      return slides[mainSwiper.activeIndex] || null;
    }
    function activeZoomSrc() {
      var slide = activeSlide();
      return slide ? slide.getAttribute('data-eg-zoom-src') : null;
    }
    function activeImg() {
      var slide = activeSlide();
      return slide ? qs('img', slide) : null;
    }
    function activeIsZoomable() {
      return !!activeZoomSrc();
    }
    function resetImgTransform(img) {
      if (!img) return;
      img.style.transform = '';
      img.style.transformOrigin = '';
      img.style.willChange = '';
    }

    var canHover =
      typeof window.matchMedia === 'function' &&
      window.matchMedia('(hover: hover) and (pointer: fine)').matches;

    function attachHoverMagnify(hostEl, getImg, isDisabled) {
      if (!hostEl) return { prime: function () {} };
      var SCALE = 2.2;

      function applyAt(clientX, clientY) {
        if (isDisabled && isDisabled()) return false;
        var img = getImg();
        if (!img) return false;
        // Always re-measure — dialog image often has 0 size until layout/load finishes.
        var rect = img.getBoundingClientRect();
        if (!rect.width || !rect.height) return false;
        img.style.willChange = 'transform';
        var x = Math.min(100, Math.max(0, ((clientX - rect.left) / rect.width) * 100));
        var y = Math.min(100, Math.max(0, ((clientY - rect.top) / rect.height) * 100));
        img.style.transformOrigin = x + '% ' + y + '%';
        img.style.transform = 'scale(' + SCALE + ')';
        return true;
      }

      function pointerOverHost(clientX, clientY) {
        var hostRect = hostEl.getBoundingClientRect();
        return (
          clientX >= hostRect.left &&
          clientX <= hostRect.right &&
          clientY >= hostRect.top &&
          clientY <= hostRect.bottom
        );
      }

      hostEl.addEventListener('mouseenter', function (e) {
        applyAt(e.clientX, e.clientY);
      });
      hostEl.addEventListener('mousemove', function (e) {
        applyAt(e.clientX, e.clientY);
      });
      hostEl.addEventListener('mouseleave', function () {
        resetImgTransform(getImg());
      });

      return {
        // Dialog opens under the cursor — mouseenter never fires; prime from the click point.
        prime: function (clientX, clientY) {
          if (typeof clientX !== 'number' || typeof clientY !== 'number') return;
          if (!pointerOverHost(clientX, clientY)) return;
          applyAt(clientX, clientY);
        },
      };
    }

    if (wantsLightbox) {
      var dialog = qs('[data-eg-zoom-dialog]');
      var dialogImg = dialog ? qs('[data-eg-zoom-img]', dialog) : null;
      var lightboxPreview = dialogImg ? dialogImg.parentElement : null;
      var zoomBtn = qs('[data-eg-zoom-open]', gallery);
      var lightboxHover = null;

      var openLightbox = function (triggerEvent) {
        if (!dialog || !dialogImg || typeof dialog.showModal !== 'function') return;
        var src = activeZoomSrc();
        if (!src) return;
        var img = activeImg();
        dialogImg.src = src;
        dialogImg.alt = img ? img.getAttribute('alt') || '' : '';
        if (img && img.naturalWidth && img.naturalHeight) {
          dialogImg.setAttribute('width', img.naturalWidth);
          dialogImg.setAttribute('height', img.naturalHeight);
        }
        resetImgTransform(dialogImg);
        dialog.showModal();

        if (!lightboxHover || !triggerEvent) return;
        var x = triggerEvent.clientX;
        var y = triggerEvent.clientY;
        var primeHover = function () {
          lightboxHover.prime(x, y);
        };
        // Layout + decode are often not ready in the same turn as showModal.
        requestAnimationFrame(function () {
          primeHover();
          requestAnimationFrame(primeHover);
        });
        if (!dialogImg.complete) {
          dialogImg.addEventListener('load', primeHover, { once: true });
        }
      };

      if (dialog && dialogImg) {
        if (zoomBtn) {
          zoomBtn.addEventListener('click', function (e) {
            e.preventDefault();
            e.stopPropagation();
            openLightbox(e);
          });
        }
        frame.addEventListener('click', function (e) {
          if (e.target.closest('[data-eg-zoom-open]')) return;
          if (e.target.closest('video, iframe, model-viewer, button, a')) return;
          if (!activeIsZoomable()) return;
          openLightbox(e);
        });
        if (canHover) {
          lightboxPreview.classList.add('eg-zoom-dialog__preview--hover-zoom');
          lightboxHover = attachHoverMagnify(lightboxPreview, function () {
            return dialogImg;
          });
        }
        dialog.addEventListener('click', function (e) {
          if (e.target === dialog) dialog.close();
        });
        dialog.addEventListener('close', function () {
          resetImgTransform(activeImg());
          resetImgTransform(dialogImg);
        });
      }

      var syncZoomBtn = function () {
        if (!zoomBtn) return;
        if (activeIsZoomable()) {
          zoomBtn.removeAttribute('hidden');
        } else {
          zoomBtn.setAttribute('hidden', '');
        }
      };
      if (mainSwiper) mainSwiper.on('slideChange', syncZoomBtn);
      syncZoomBtn();
    }

    if (wantsHover && canHover) {
      frame.classList.add('eg-gallery__main--hover-zoom');
      attachHoverMagnify(
        frame,
        function () {
          return activeIsZoomable() ? activeImg() : null;
        },
        null
      );
      if (mainSwiper) {
        mainSwiper.on('slideChangeTransitionStart', function () {
          mainSwiper.slides.forEach(function (slide) {
            resetImgTransform(qs('img', slide));
          });
        });
      }
    }
  }

  var FOCUSABLE =
    'a[href], button:not([disabled]), input:not([disabled]), select:not([disabled]), textarea:not([disabled]), [tabindex]:not([tabindex="-1"])';

  var closeSuggestions = null;

  function setSearchPanelOpen(open, returnFocus) {
    var panel = qs('[data-eg-search-panel]');
    if (!panel) return;
    if (open === panel.classList.contains('is-open')) return;

    panel.classList.toggle('is-open', open);

    qsa('[data-eg-toggle-search][aria-expanded]').forEach(function (btn) {
      btn.setAttribute('aria-expanded', open ? 'true' : 'false');
    });

    if (!open && closeSuggestions) closeSuggestions();

    if (open) {
      var input = qs('input[name="q"]', panel);
      if (input) input.focus();
    } else if (returnFocus) {
      var opener = qs('[data-eg-toggle-search][aria-expanded]');
      if (opener) opener.focus();
    }
  }

  function initSearchToggle() {
    var panel = qs('[data-eg-search-panel]');
    if (!panel || panel.dataset.egSearchInit === '1') return;
    panel.dataset.egSearchInit = '1';

    qsa('[data-eg-toggle-search]').forEach(function (btn) {
      btn.addEventListener('click', function (e) {
        e.preventDefault();
        setSearchPanelOpen(!panel.classList.contains('is-open'), true);
      });
    });
  }

  var SUGGEST_TYPES = 'query,product,collection,page,article';
  var SUGGEST_FIELDS = 'title,product_type,variants.title,variants.sku,vendor';
  var SUGGEST_MIN_CHARS = 1;
  var SUGGEST_CACHE_MAX = 30;
  var SUGGEST_CACHE_VER = 'b2b-wholesale-v1';

  function initPredictiveSearch() {
    var panel = qs('[data-eg-search-panel]');
    if (!panel || panel.dataset.egSuggestInit === '1') return;

    var endpoint = panel.getAttribute('data-eg-suggest-url');
    var results = qs('[data-eg-suggest]', panel);
    var input = qs('input[name="q"]', panel);
    var form = qs('form', panel);
    if (!endpoint || !results || !input || !form) return;
    panel.dataset.egSuggestInit = '1';

    var status = qs('[data-eg-suggest-status]', panel);
    var filterSelect = qs('[data-eg-suggest-filter]', panel);
    var limit = panel.getAttribute('data-eg-suggest-limit') || '4';
    var scope = panel.getAttribute('data-eg-suggest-scope') || 'each';
    var cache = {};
    var cacheOrder = [];
    var controller = null;

    function cacheSet(key, markup) {
      if (cache[key] === undefined) {
        cacheOrder.push(key);
        while (cacheOrder.length > SUGGEST_CACHE_MAX) {
          delete cache[cacheOrder.shift()];
        }
      }
      cache[key] = markup;
    }

    function filterType() {
      return filterSelect ? filterSelect.getAttribute('data-filter-type') || '' : '';
    }

    function filterValue() {
      return filterSelect ? filterSelect.value.trim() : '';
    }

    function queryKey(term) {
      return [SUGGEST_CACHE_VER, term.toLowerCase(), filterType(), filterValue().toLowerCase()].join('\u0000');
    }

    function optionEls() {
      return qsa('[role="option"]', results).filter(isReachable);
    }

    function activeEl() {
      return qs('[aria-selected="true"]', results);
    }

    function clearActive() {
      var prev = activeEl();
      if (prev) prev.setAttribute('aria-selected', 'false');
      input.removeAttribute('aria-activedescendant');
    }

    function setActive(el) {
      clearActive();
      if (!el) return;
      el.setAttribute('aria-selected', 'true');
      if (el.id) input.setAttribute('aria-activedescendant', el.id);
      if (typeof el.scrollIntoView === 'function') el.scrollIntoView({ block: 'nearest' });
    }

    function abortPending() {
      if (!controller) return;
      controller.abort();
      controller = null;
    }

    function close() {
      abortPending();
      clearActive();
      results.hidden = true;
      input.setAttribute('aria-expanded', 'false');
    }

    function reset() {
      close();
      results.innerHTML = '';
    }

    function announce() {
      if (!status) return;
      var count = qs('[data-eg-suggest-count]', results);
      status.textContent = count ? count.textContent.trim() : '';
    }

    function show(markup) {
      results.innerHTML = markup;
      results.hidden = false;
      input.setAttribute('aria-expanded', 'true');
      clearActive();
      announce();
    }

    function move(step) {
      var list = optionEls();
      if (!list.length) return;
      var idx = list.indexOf(activeEl());
      var next;
      if (step > 0) next = idx < 0 || idx === list.length - 1 ? list[0] : list[idx + 1];
      else next = idx <= 0 ? list[list.length - 1] : list[idx - 1];
      setActive(next);
    }

    function request(term) {
      var key = queryKey(term);
      if (cache[key] != null) {
        show(cache[key]);
        return;
      }

      abortPending();
      controller = typeof AbortController !== 'undefined' ? new AbortController() : null;

      var value = filterValue();
      var q = value ? filterType() + ':' + value + '+* ' + term : term;

      var url =
        endpoint +
        '?q=' +
        encodeURIComponent(q) +
        '&section_id=predictive-search' +
        '&options[prefix]=last' +
        '&resources[type]=' +
        SUGGEST_TYPES +
        '&resources[limit]=' +
        encodeURIComponent(limit) +
        '&resources[limit_scope]=' +
        encodeURIComponent(scope) +
        '&resources[options][fields]=' +
        SUGGEST_FIELDS;

      fetch(url, {
        credentials: 'same-origin',
        signal: controller ? controller.signal : undefined,
      })
        .then(function (res) {
          if (!res.ok) throw new Error('Predictive search failed: ' + res.status);
          return res.text();
        })
        .then(function (text) {
          var section = new DOMParser()
            .parseFromString(text, 'text/html')
            .querySelector('#shopify-section-predictive-search');
          var markup = section ? section.innerHTML.trim() : '';
          cacheSet(key, markup);
          if (queryKey(input.value.trim()) !== key) return;
          if (!markup) close();
          else show(markup);
        })
        .catch(function (err) {
          if (err && err.name === 'AbortError') return;
          close();
        });
    }

    var requestDebounced = debounce(function () {
      var term = input.value.trim();
      if (term.length < SUGGEST_MIN_CHARS) {
        reset();
        return;
      }
      request(term);
    }, 250);

    input.addEventListener('input', requestDebounced);

    input.addEventListener('focus', function () {
      if (results.hidden) requestDebounced();
    });

    if (filterSelect) {
      filterSelect.addEventListener('change', requestDebounced);
    }

    input.addEventListener('keydown', function (e) {
      if (e.key === 'ArrowDown' || e.key === 'ArrowUp') {
        if (results.hidden) return;
        e.preventDefault();
        move(e.key === 'ArrowDown' ? 1 : -1);
        return;
      }
      if (e.key === 'Escape' && !results.hidden) {
        e.stopPropagation();
        close();
      }
    });

    form.addEventListener('submit', function (e) {
      var active = activeEl();
      if (!active) return;
      var href = active.tagName === 'A' ? active.href : (active.querySelector('a') || {}).href;
      if (!href) return;
      e.preventDefault();
      window.location.assign(href);
    });

    results.addEventListener('mousedown', function (e) {
      if (e.button === 0) e.preventDefault();
    });

    panel.addEventListener('focusout', function () {
      window.setTimeout(function () {
        if (!panel.contains(document.activeElement)) close();
      }, 0);
    });

    closeSuggestions = reset;
  }

  function lockScroll(locked) {
    var root = document.documentElement;
    if (locked) {
      var gap = window.innerWidth - root.clientWidth;
      root.style.setProperty('--eg-scrollbar-w', gap > 0 ? gap + 'px' : '0px');
      root.classList.add('eg-scroll-locked');
    } else {
      root.classList.remove('eg-scroll-locked');
      root.style.removeProperty('--eg-scrollbar-w');
    }
  }

  var mobileMenuLastFocused = null;

  function isMobileMenuOpen() {
    var panel = qs('#eg-mobile-panel');
    return !!panel && panel.classList.contains('is-open');
  }

  function setMobileMenuOpen(open) {
    var panel = qs('#eg-mobile-panel');
    var opener = qs('[data-eg-menu-open]');
    var backdrop = qs('.eg-mobile-backdrop');
    if (!panel || !opener || open === isMobileMenuOpen()) return;

    if (open) {
      var active = document.activeElement;
      mobileMenuLastFocused =
        active && active !== document.body && typeof active.focus === 'function' ? active : opener;
      qsa('details[open]', panel).forEach(function (d) {
        d.open = false;
      });
    }

    panel.classList.toggle('is-open', open);
    if (backdrop) backdrop.classList.toggle('is-open', open);

    opener.setAttribute('aria-expanded', open ? 'true' : 'false');
    lockScroll(open);

    if (open) {
      var first = Array.prototype.filter.call(panel.querySelectorAll(FOCUSABLE), isReachable)[0];
      if (first) first.focus({ preventScroll: true });
    } else {
      var returnTo = mobileMenuLastFocused;
      if (!returnTo || !returnTo.isConnected) returnTo = opener;
      returnTo.focus({ preventScroll: true });
      mobileMenuLastFocused = null;
    }
  }

  function isReachable(el) {
    if (!el.offsetParent) return false;
    var cs = window.getComputedStyle(el);
    return cs.visibility !== 'hidden' && cs.display !== 'none';
  }

  function trapMobileMenuTab(e) {
    var panel = qs('#eg-mobile-panel');
    if (!panel) return;
    var items = Array.prototype.filter.call(panel.querySelectorAll(FOCUSABLE), isReachable);
    if (!items.length) return;

    var first = items[0];
    var last = items[items.length - 1];
    if (e.shiftKey && document.activeElement === first) {
      e.preventDefault();
      last.focus();
    } else if (!e.shiftKey && document.activeElement === last) {
      e.preventDefault();
      first.focus();
    }
  }

  function initMobileMenu() {
    var panel = qs('#eg-mobile-panel');
    if (!panel || panel.dataset.egMenuInit === '1') return;
    panel.dataset.egMenuInit = '1';

    var backdrop = qs('.eg-mobile-backdrop');
    panel.removeAttribute('hidden');
    if (backdrop) backdrop.removeAttribute('hidden');

    var opener = qs('[data-eg-menu-open]');
    if (opener) {
      opener.addEventListener('click', function () {
        setMobileMenuOpen(true);
      });
    }
    qsa('[data-eg-menu-close]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        setMobileMenuOpen(false);
      });
    });

    panel.addEventListener('click', function (e) {
      var back = e.target.closest('[data-eg-submenu-back]');
      if (!back) return;
      var open = back.closest('details');
      if (!open) return;
      open.open = false;
      var summary = open.querySelector(':scope > summary');
      if (summary) summary.focus({ preventScroll: true });
    });
  }

  function initHeaderGlobalListeners() {
    if (initHeaderGlobalListeners.__bound) return;
    initHeaderGlobalListeners.__bound = true;

    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') {
        setSearchPanelOpen(false, true);
        closeMegaMenu(true);
        if (isMobileMenuOpen()) setMobileMenuOpen(false);
        return;
      }
      if (e.key === 'Tab' && isMobileMenuOpen()) trapMobileMenuTab(e);
    });

    document.addEventListener('click', function (e) {
      var details = qs('details[data-eg-mega]');
      if (details && details.open && !details.contains(e.target)) closeMegaMenu(false);
    });

    var mq = window.matchMedia('(min-width: 1200px)');
    function onBreakpoint(e) {
      if (e.matches) setMobileMenuOpen(false);
    }
    if (mq.addEventListener) mq.addEventListener('change', onBreakpoint);
    else if (mq.addListener) mq.addListener(onBreakpoint);
  }

  var COLLECTION_FILTERS_MQ = '(min-width: 768px)';

  function collectionFilterSheet(root) {
    if (root) {
      var scoped = qs('[data-eg-filter-sheet]', root);
      if (scoped) return scoped;
    }
    return qs('[data-eg-filter-sheet]');
  }

  function closeCollectionFilterSheet(sheet) {
    if (sheet && sheet.open) sheet.close();
  }

  /**
   * showModal() supplies the focus trap, Escape handling and inert background; it does
   * not stop the page behind from scrolling, so the lock is applied here.
   */
  function openCollectionFilterSheet(sheet) {
    if (!sheet || sheet.open || typeof sheet.showModal !== 'function') return;
    sheet.showModal();
    lockScroll(true);
    syncCollectionFiltersToggle();
  }

  /**
   * The one button collapses the desktop sidebar and opens the mobile sheet, so its
   * expanded state means different things per breakpoint. Liquid can't know the
   * viewport, so the attribute is set here rather than rendered server-side.
   */
  function syncCollectionFiltersToggle() {
    var isDesk = window.matchMedia(COLLECTION_FILTERS_MQ).matches;
    qsa('[data-eg-open-filters]').forEach(function (btn) {
      var root = btn.closest ? btn.closest('[data-eg-collection-root]') : null;
      var expanded;
      if (isDesk) {
        expanded = !(root && root.classList.contains('eg-collection--filters-collapsed'));
      } else {
        var sheet = collectionFilterSheet(root);
        expanded = !!(sheet && sheet.open);
      }
      btn.setAttribute('aria-expanded', expanded ? 'true' : 'false');
    });
  }

  function getCollectionAjaxRoot() {
    return qs('[data-eg-section-id][data-eg-ajax-filters]');
  }

  function sectionWrapperEl(sectionId) {
    return sectionId ? document.getElementById('shopify-section-' + sectionId) : null;
  }

  /** URL param carrying a multi-category selection, e.g. `?types=anchors,hardware`. */
  var CATEGORY_PARAM = 'types';

  /** A Product type row: a checkbox pointing at a category collection, or at All products. */
  function isCollectionNavInput(t) {
    return !!(t && t.type === 'checkbox' && t.hasAttribute && t.hasAttribute('data-eg-collection-nav'));
  }

  function collectionNavPath(input) {
    var href = input && input.getAttribute('data-eg-collection-nav');
    if (!href) return '';
    try {
      return new URL(href, window.location.origin).pathname.replace(/\/+$/, '');
    } catch (err) {
      return '';
    }
  }

  function collectionNavHandle(input) {
    var path = collectionNavPath(input);
    return path ? path.slice(path.lastIndexOf('/') + 1) : '';
  }

  /** Product type rows in DOM order, which is the category order the panel renders. */
  function collectionNavInputs(scope) {
    return qsa('input[type="checkbox"][data-eg-collection-nav]', scope || document);
  }

  function collectionNavLabel(input) {
    var row = input.closest ? input.closest('.eg-filter-row') : null;
    var text = row ? row.querySelector('span:not(.eg-filter-count)') : null;
    return text ? text.textContent.trim() : '';
  }

  function allCollectionPath(root) {
    var href = root && root.getAttribute('data-eg-all-collection-url');
    if (!href) return '';
    try {
      return new URL(href, window.location.origin).pathname.replace(/\/+$/, '');
    } catch (err) {
      return '';
    }
  }

  /**
   * Checked categories, in panel order, without All products. Read from the panel the shopper
   * touched: the sidebar and the mobile sheet render the same rows, and only one is in use.
   */
  function checkedCategoryHandles(root, panel) {
    var allPath = allCollectionPath(root);
    var handles = [];
    collectionNavInputs(panel || root).forEach(function (input) {
      if (!input.checked || collectionNavPath(input) === allPath) return;
      var handle = collectionNavHandle(input);
      if (handle && handles.indexOf(handle) === -1) handles.push(handle);
    });
    return handles;
  }

  /** Put `handles` on every Product type panel, so the sidebar and the sheet never disagree. */
  function syncCategorySelection(root, handles) {
    var allPath = allCollectionPath(root);
    collectionNavInputs(root).forEach(function (input) {
      if (collectionNavPath(input) === allPath) {
        // All products only owns the view when nothing else is picked.
        input.checked = handles.length === 0;
        input.disabled = false;
        return;
      }
      input.checked = handles.indexOf(collectionNavHandle(input)) !== -1;
    });
  }

  /** Full page when not on collection AJAX root (e.g. theme editor preview). */
  function initCollectionNavCheckboxes() {
    if (initCollectionNavCheckboxes.__bound) return;
    initCollectionNavCheckboxes.__bound = true;
    document.addEventListener(
      'change',
      function (e) {
        var t = e.target;
        if (!t || t.type !== 'checkbox' || !t.hasAttribute('data-eg-collection-nav')) return;
        if (t.closest && t.closest('[data-eg-ajax-filters]')) return;
        if (t.disabled) return;
        if (!t.checked) {
          var rootAll = document.querySelector('[data-eg-all-collection-url]');
          var allU = rootAll && rootAll.getAttribute('data-eg-all-collection-url');
          if (allU) window.location.assign(allU);
          return;
        }
        var url = t.getAttribute('data-eg-collection-nav');
        if (!url) return;
        window.location.assign(url);
      },
      true
    );
  }

  function initCollectionAjaxFilters() {
    if (initCollectionAjaxFilters.__bound) return;
    initCollectionAjaxFilters.__bound = true;

    var mqDesk = window.matchMedia('(min-width: 768px)');
    var priceRenderSwap = false;

    function busy(sectionId, on) {
      var wrap = sectionWrapperEl(sectionId);
      if (!wrap) return;
      if (on) wrap.setAttribute('data-eg-ajax-busy', '1');
      else wrap.removeAttribute('data-eg-ajax-busy');
    }

    function getSortSelect(root) {
      return root.querySelector('[data-eg-collection-sort-form] [data-eg-sort-select], .eg-sort-select');
    }

    function mergeSortIntoParams(root, params) {
      var sortEl = getSortSelect(root);
      if (sortEl && sortEl.name) params.set(sortEl.name, sortEl.value);
    }

    /**
     * Request one section render, without touching the page.
     * @see https://shopify.dev/docs/api/ajax/section-rendering#request-a-single-section
     */
    function requestSectionHtml(sectionId, pathname, params) {
      var qs = params.toString();
      var url = pathname + (qs ? '?' + qs + '&' : '?') + 'section_id=' + encodeURIComponent(sectionId);
      return fetch(url, {
        credentials: 'same-origin',
        headers: { 'X-Requested-With': 'XMLHttpRequest', Accept: 'text/html, application/json' },
      })
        .then(function (r) {
          if (r.status === 404) throw new Error('section404');
          if (!r.ok) throw new Error('http');
          var ct = (r.headers.get('content-type') || '').toLowerCase();
          if (ct.indexOf('application/json') !== -1) {
            return r.json().then(function (data) {
              var html =
                data.sections &&
                (data.sections[sectionId] ||
                  data.sections[Object.keys(data.sections)[0]]);
              if (!html) throw new Error('nojson');
              return html;
            });
          }
          return r.text();
        })
        .then(function (html) {
          if (!html || typeof html !== 'string') throw new Error('empty');
          return html.trim();
        });
    }

    /**
     * Section HTML for `pathname` (current collection or another, e.g. Product type shortcuts),
     * swapped into the page.
     */
    function fetchSectionAtPath(root, pathname, searchParams) {
      var sectionId = root.getAttribute('data-eg-section-id');
      if (!sectionId || !searchParams) return Promise.resolve();
      var p = new URLSearchParams(searchParams);
      mergeSortIntoParams(root, p);
      p.delete('sections');
      p.delete('section_id');
      var path = pathname || window.location.pathname;
      busy(sectionId, true);
      return requestSectionHtml(sectionId, path, p)
        .then(function (html) {
          var el = sectionWrapperEl(sectionId);
          if (!el) throw new Error('nodel');
          var priceFocus = capturePriceFocus();
          var focusedId = priceFocus ? null : captureFocusedControlId(sectionId);
          var sheetWasOpen = filterSheetWasOpen(sectionId);
          // Swapping the section blurs the focused input and refocusing it blurs another;
          // neither is the shopper leaving the price filter, so hold the commit handlers off.
          priceRenderSwap = true;
          try {
            el.outerHTML = html;
            p.delete('section_id');
            var forBar = new URLSearchParams(p);
            forBar.delete('sections');
            var qsStr = forBar.toString();
            history.pushState({}, '', path + (qsStr ? '?' + qsStr : ''));
            syncHeaderHeightCssVar();
            if (typeof window.__egApplyCollectionLayout === 'function') {
              window.__egApplyCollectionLayout();
            }
            syncPriceForms();
            // A closed dialog holds no focusable content, so reopen before restoring focus.
            if (sheetWasOpen) {
              var wrap = sectionWrapperEl(sectionId);
              openCollectionFilterSheet(wrap && wrap.querySelector('[data-eg-filter-sheet]'));
            }
            restorePriceFocus(priceFocus);
            restoreFocusedControlId(focusedId);
            syncCollectionFiltersToggle();
            initCollectionDeferredCounts();
            announceCollectionResults(sectionId);
          } finally {
            priceRenderSwap = false;
          }
        })
        .catch(function () {
          p.delete('sections');
          p.delete('section_id');
          var fallback = path + (p.toString() ? '?' + p.toString() : '');
          window.location.assign(fallback);
        })
        .finally(function () {
          busy(sectionId, false);
        });
    }

    function categoryNavPath(root, handle) {
      var found = '';
      collectionNavInputs(root).forEach(function (input) {
        if (!found && collectionNavHandle(input) === handle) found = collectionNavPath(input);
      });
      return found;
    }

    /** The grid, recreated if the current render is the "no matches" message instead. */
    function productGridEl(root) {
      var grid = root.querySelector('[data-eg-collection-product-grid]');
      if (grid) return grid;
      var empty = root.querySelector('.eg-collection-empty');
      if (!empty || !empty.parentNode) return null;
      grid = document.createElement('div');
      grid.className = 'eg-product-grid eg-product-grid--wide';
      grid.setAttribute('data-eg-collection-product-grid', '');
      empty.parentNode.replaceChild(grid, empty);
      return grid;
    }

    /** Retitle the hero for a selection no single collection describes. */
    function showMergedHero(root, handles, count) {
      var labels = [];
      collectionNavInputs(root).forEach(function (input) {
        var handle = collectionNavHandle(input);
        if (handles.indexOf(handle) === -1 || labels.indexOf(handle) !== -1) return;
        var label = collectionNavLabel(input);
        if (label && labels.indexOf(label) === -1) labels.push(label);
      });
      var title = root.querySelector('.eg-collection-hero__title');
      if (title && labels.length) title.textContent = labels.join(' + ');
      var counter = root.querySelector('.eg-collection-hero__count');
      var format = counter && counter.getAttribute('data-eg-count-format');
      var text = format ? format.replace('__N__', count) : String(count);
      if (counter) {
        // Detach it from the count endpoint, which only knows per-collection totals.
        counter.removeAttribute('data-eg-count-handle');
        counter.textContent = text;
      }
      return text;
    }

    function showMergedEmpty(root, grid) {
      var message = root.getAttribute('data-eg-no-matches') || '';
      var p = document.createElement('p');
      p.className = 'eg-collection-empty';
      p.setAttribute('data-eg-results-text', message);
      p.textContent = message;
      if (grid.parentNode) grid.parentNode.replaceChild(p, grid);
    }

    /**
     * Show several categories at once.
     *
     * These rows are collections, and Shopify has no filter for "is in this collection", so the
     * combination is assembled here: fetch each selected collection and stitch its cards into the
     * current grid, in panel order, each category keeping its admin order. Every category fits in
     * one page of the section, so one request per category covers all of it — which is also why
     * the combined view lists everything and drops pagination.
     *
     * The page is written once, when every request has answered, so a click renders one time.
     */
    function renderMergedCategories(root, handles, searchParams) {
      var sectionId = root.getAttribute('data-eg-section-id');
      if (!sectionId || handles.length === 0) return Promise.resolve();
      var base = new URLSearchParams();
      // Price bounds still apply; each fetch has Shopify filter its own collection.
      new URLSearchParams(searchParams || window.location.search).forEach(function (val, key) {
        if (key.indexOf('filter.') === 0 && val !== '') base.append(key, val);
      });
      mergeSortIntoParams(root, base);
      var paths = handles.map(function (handle) {
        return categoryNavPath(root, handle);
      });
      if (paths.indexOf('') !== -1) return Promise.resolve();
      var failed = 0;
      busy(sectionId, true);
      return Promise.all(
        paths.map(function (path) {
          return requestSectionHtml(sectionId, path, new URLSearchParams(base)).catch(function () {
            failed++;
            return '';
          });
        })
      )
        .then(function (parts) {
          // Nothing came back: keep the current results rather than emptying the grid.
          if (failed === paths.length) return;
          var grid = productGridEl(root);
          if (!grid) return;
          var scratch = document.implementation.createHTMLDocument('');
          var seen = {};
          var cards = [];
          parts.forEach(function (html) {
            if (!html) return;
            scratch.body.innerHTML = html;
            qsa('[data-eg-collection-product-grid] > *', scratch.body).forEach(function (card) {
              // A product can sit in more than one category; the first category to list it wins.
              var link = card.querySelector('a[href*="/products/"]');
              var key = link ? link.getAttribute('href').split('?')[0] : '';
              if (key) {
                if (seen[key]) return;
                seen[key] = true;
              }
              cards.push(document.importNode(card, true));
            });
          });
          grid.innerHTML = '';
          cards.forEach(function (card) {
            grid.appendChild(card);
          });
          grid.setAttribute('data-eg-results-text', showMergedHero(root, handles, cards.length));
          if (cards.length === 0) showMergedEmpty(root, grid);
          var pager = root.querySelector('.eg-pagination');
          if (pager && pager.parentNode) pager.parentNode.removeChild(pager);
          var urlParams = new URLSearchParams(base);
          urlParams.set(CATEGORY_PARAM, handles.join(','));
          history.pushState({}, '', window.location.pathname + '?' + urlParams.toString());
          syncCategorySelection(root, handles);
          if (typeof window.__egApplyCollectionLayout === 'function') {
            window.__egApplyCollectionLayout();
          }
          syncPriceForms();
          announceCollectionResults(sectionId);
        })
        .finally(function () {
          busy(sectionId, false);
        });
    }

    function fetchSection(root, searchParams) {
      // Sort and price changes must not throw away a multi-category selection.
      var merged = checkedCategoryHandles(root);
      if (merged.length > 1) return renderMergedCategories(root, merged, searchParams);
      return fetchSectionAtPath(root, window.location.pathname, searchParams);
    }

    /** Load one collection (or All products) the way the server renders it. */
    function navigateToCollection(root, path, params) {
      if (!path) return;
      try {
        fetchSectionAtPath(root, path, params || new URLSearchParams());
      } catch (err) {
        window.location.assign(path);
      }
    }

    /** Re-apply a reloaded or shared `?types=` selection; the server renders one collection only. */
    function restoreCategorySelection(root) {
      var params = new URLSearchParams(window.location.search);
      var raw = params.get(CATEGORY_PARAM);
      if (!raw) return;
      params.delete(CATEGORY_PARAM);
      var wanted = raw.split(',').map(function (part) {
        return part.trim();
      });
      // Panel order, not URL order, so a shared link combines the same way it was built.
      var handles = [];
      collectionNavInputs(root).forEach(function (input) {
        var handle = collectionNavHandle(input);
        if (handle && wanted.indexOf(handle) !== -1 && handles.indexOf(handle) === -1) handles.push(handle);
      });
      if (handles.length === 0) return;
      syncCategorySelection(root, handles);
      renderMergedCategories(root, handles, params);
    }

    function paramsFromForm(form) {
      if (!form) return null;
      var p = new URLSearchParams(new FormData(form));
      p.forEach(function (val, key) {
        if (val === '') p.delete(key);
      });
      return p;
    }

    function isFilterFormCheckbox(t) {
      return t && t.type === 'checkbox' && t.form && t.form.getAttribute('data-eg-filter-form');
    }

    /**
     * Price range state for a filter form.
     * `ok` — the entered bounds are numbers >= 0 and min <= max (an empty field is not an error).
     * `empty` — neither bound was entered, so there is nothing to apply.
     */
    function priceRangeState(form) {
      var minEl = form.querySelector('[data-eg-price-bound="min"]');
      var maxEl = form.querySelector('[data-eg-price-bound="max"]');
      if (!minEl && !maxEl) return null;
      var bounds = [minEl, maxEl].map(function (el) {
        var raw = el ? String(el.value).trim() : '';
        if (raw === '') return null;
        var num = Number(raw);
        return isFinite(num) ? num : NaN;
      });
      var min = bounds[0];
      var max = bounds[1];
      var invalid =
        (min !== null && (isNaN(min) || min < 0)) ||
        (max !== null && (isNaN(max) || max < 0)) ||
        (min !== null && max !== null && min > max);
      return { ok: !invalid, empty: min === null && max === null };
    }

    /**
     * Numeric identity of the entered range, so "20" and a re-rendered "20.00" compare equal.
     */
    function priceKey(form) {
      return ['min', 'max']
        .map(function (bound) {
          var el = form.querySelector('[data-eg-price-bound="' + bound + '"]');
          var raw = el ? String(el.value).trim() : '';
          if (raw === '') return '';
          var num = Number(raw);
          return isFinite(num) ? String(num) : raw;
        })
        .join('|');
    }

    /** True once the entered range differs from the one currently applied to the page. */
    function priceNeedsApply(form) {
      return priceKey(form) !== form.__egAppliedPriceKey;
    }

    function filterSheetWasOpen(sectionId) {
      var wrap = sectionWrapperEl(sectionId);
      var sheet = wrap ? wrap.querySelector('[data-eg-filter-sheet]') : null;
      return !!(sheet && sheet.open);
    }

    /**
     * The swap replaces every control in the section, so whatever had focus is destroyed and
     * focus falls to <body>. The rendered ids are deterministic, so the same control can be
     * found again afterwards.
     */
    function captureFocusedControlId(sectionId) {
      var el = document.activeElement;
      var wrap = sectionWrapperEl(sectionId);
      if (!el || !el.id || !wrap || !wrap.contains(el)) return null;
      return el.id;
    }

    function restoreFocusedControlId(id) {
      var el = id ? document.getElementById(id) : null;
      if (!el) return;
      try {
        el.focus({ preventScroll: true });
      } catch (err) {
        el.focus();
      }
    }

    /**
     * Lives on <body> rather than inside the section: a live region has to be present before
     * its text changes to be announced, and the section itself is replaced wholesale.
     */
    function announceCollectionResults(sectionId) {
      var wrap = sectionWrapperEl(sectionId);
      var src = wrap ? wrap.querySelector('[data-eg-results-text]') : null;
      var text = src ? src.getAttribute('data-eg-results-text') : '';
      if (!text) return;
      var region = qs('#eg-collection-live');
      if (!region) {
        region = document.createElement('div');
        region.id = 'eg-collection-live';
        region.className = 'eg-visually-hidden';
        region.setAttribute('role', 'status');
        region.setAttribute('aria-live', 'polite');
        document.body.appendChild(region);
      }
      region.textContent = '';
      window.setTimeout(function () {
        region.textContent = text;
      }, 60);
    }

    /**
     * After pagination, scroll to the top of the collection.
     * Do not target `.eg-coll-toolbar` — it is sticky, so at the page bottom its
     * getBoundingClientRect stays near the header and scroll appears to do nothing.
     */
    function scrollCollectionResultsIntoView(sectionId) {
      function run() {
        var wrap = sectionWrapperEl(sectionId);
        var target =
          (wrap && wrap.querySelector('[data-eg-collection-root]')) ||
          (wrap && wrap.querySelector('.eg-collection-hero')) ||
          wrap;
        if (!target) {
          window.scrollTo({ top: 0, behavior: 'smooth' });
          return;
        }
        var headerOffset = 0;
        try {
          headerOffset =
            parseFloat(
              getComputedStyle(document.documentElement).getPropertyValue('--eg-header-height')
            ) || 0;
        } catch (err) {
          headerOffset = 0;
        }
        if (!headerOffset) {
          var headerBar = qs('.eg-header');
          headerOffset = headerBar ? headerBar.offsetHeight : 0;
        }
        var top = target.getBoundingClientRect().top + window.pageYOffset - headerOffset;
        window.scrollTo({ top: Math.max(0, top), behavior: 'smooth' });
      }
      // Wait a frame so the swapped section has laid out before measuring.
      window.requestAnimationFrame(function () {
        window.requestAnimationFrame(run);
      });
    }

    /**
     * A render replaces the price inputs, so a shopper typing during one would lose both the
     * caret and any digits added while the request was in flight. Snapshot before the swap.
     */
    function capturePriceFocus() {
      var el = document.activeElement;
      if (!el || !el.matches || !el.matches('.eg-filter-price__input')) return null;
      var caret = null;
      try {
        caret = { start: el.selectionStart, end: el.selectionEnd };
      } catch (err) {
        caret = null; // type="number" forbids selection access in some browsers
      }
      return {
        formKind: el.form ? el.form.getAttribute('data-eg-filter-form') : null,
        bound: el.getAttribute('data-eg-price-bound'),
        value: el.value,
        caret: caret,
      };
    }

    function restorePriceFocus(snapshot) {
      if (!snapshot || !snapshot.formKind || !snapshot.bound) return;
      var el = document.querySelector(
        'form[data-eg-filter-form="' + snapshot.formKind + '"] [data-eg-price-bound="' + snapshot.bound + '"]'
      );
      if (!el) return;
      // Keep what was typed rather than the value echoed back by the render.
      el.value = snapshot.value;
      // preventScroll: the shopper may have scrolled to the grid while the request was in
      // flight, and refocusing must not yank the page back to the filter.
      try {
        el.focus({ preventScroll: true });
      } catch (err) {
        el.focus();
      }
      if (snapshot.caret) {
        try {
          el.setSelectionRange(snapshot.caret.start, snapshot.caret.end);
        } catch (err) {
          /* not selectable */
        }
      }
      syncPriceGoState(el.form);
    }

    /**
     * Long enough to type a multi-digit price, or pause mid-number, without applying a
     * half-entered value.
     */
    var PRICE_DEBOUNCE_MS = 800;
    var priceDebounceTimer;

    function cancelPriceApply() {
      window.clearTimeout(priceDebounceTimer);
    }

    function schedulePriceApply(root, form) {
      cancelPriceApply();
      priceDebounceTimer = window.setTimeout(function () {
        applyPriceFilter(root, form);
      }, PRICE_DEBOUNCE_MS);
    }

    /** Apply the typed price range, if it is usable and not already applied. */
    function applyPriceFilter(root, form) {
      cancelPriceApply();
      // A render detaches the old form, which can still emit a trailing change event —
      // and closest() happily resolves inside the detached subtree.
      if (!document.contains(form)) return;
      var state = priceRangeState(form);
      if (!state || !state.ok || !priceNeedsApply(form)) return;
      // Claim the range up front: change and focusout both fire on the way out of a field,
      // and only one of them should reach the network. The render re-baselines this anyway.
      form.__egAppliedPriceKey = priceKey(form);
      var p = paramsFromForm(form);
      if (p) fetchSection(root, p);
    }

    /** Enable a price filter's Go button only for a range that is worth submitting. */
    function syncPriceGoState(form) {
      var go = form.querySelector('.eg-filter-price__go');
      if (!go) return;
      var state = priceRangeState(form);
      go.disabled = !state || !state.ok || state.empty;
    }

    /**
     * Run after every render: the markup echoes the applied range, so it is also the point
     * where each form's "already applied" baseline is re-established.
     */
    function syncPriceForms(scope) {
      var forms = (scope || document).querySelectorAll('form[data-eg-filter-form]');
      Array.prototype.forEach.call(forms, function (form) {
        syncPriceGoState(form);
        form.__egAppliedPriceKey = priceKey(form);
      });
    }

    document.addEventListener(
      'change',
      function (e) {
        var t = e.target;
        var root = t.closest ? t.closest('[data-eg-ajax-filters]') : null;
        if (!root) return;
        if (isCollectionNavInput(t)) {
          if (t.disabled) return;
          var allPath = allCollectionPath(root);
          // All products is a reset, so it never combines with a category.
          if (collectionNavPath(t) === allPath) {
            syncCategorySelection(root, []);
            navigateToCollection(root, allPath);
            return;
          }
          var panel = t.closest ? t.closest('.eg-filter-group--product-type-static') : null;
          var picked = checkedCategoryHandles(root, panel);
          syncCategorySelection(root, picked);
          if (picked.length === 0) {
            navigateToCollection(root, allPath);
          } else if (picked.length === 1) {
            // A single category has a page of its own: let the server render it.
            navigateToCollection(root, categoryNavPath(root, picked[0]));
          } else {
            renderMergedCategories(root, picked, new URLSearchParams(window.location.search));
          }
          return;
        }
        if (isFilterFormCheckbox(t)) {
          e.preventDefault();
          var p = paramsFromForm(t.form);
          if (p) fetchSection(root, p);
          return;
        }
        // Enter / stepper commits immediately rather than waiting out the debounce.
        if (!priceRenderSwap && t.matches('.eg-filter-price__input') && t.form && t.form.getAttribute('data-eg-filter-form')) {
          syncPriceGoState(t.form);
          if (document.activeElement !== t) applyPriceFilter(root, t.form);
          return;
        }
        if (t.matches('[data-eg-sort-select]')) {
          var desk = root.querySelector('form[data-eg-filter-form="desk"]');
          var mob = root.querySelector('form[data-eg-filter-form="mob"]');
          var sortForm = root.querySelector('[data-eg-collection-sort-form]');
          var f = mqDesk.matches && desk ? desk : mob || desk;
          var p = f ? paramsFromForm(f) : sortForm ? paramsFromForm(sortForm) : null;
          if (p) fetchSection(root, p);
        }
      },
      true
    );

    document.addEventListener(
      'input',
      function (e) {
        var t = e.target;
        if (!t.matches('.eg-filter-price__input')) return;
        var root = t.closest ? t.closest('[data-eg-ajax-filters]') : null;
        if (!root || !t.form || !t.form.getAttribute('data-eg-filter-form')) return;
        // Applies once typing pauses; focus and the typed value survive the render.
        syncPriceGoState(t.form);
        schedulePriceApply(root, t.form);
      },
      true
    );

    document.addEventListener(
      'focusout',
      function (e) {
        if (priceRenderSwap) return;
        var t = e.target;
        if (!t.matches || !t.matches('.eg-filter-price__input')) return;
        var root = t.closest ? t.closest('[data-eg-ajax-filters]') : null;
        if (!root || !t.form || !t.form.getAttribute('data-eg-filter-form')) return;
// Moving to the other bound, or to Go (which submits anyway), is not leaving the filter.
        var next = e.relatedTarget;
        if (
          next &&
          next.matches &&
          next.matches('.eg-filter-price__input, .eg-filter-price__go') &&
          next.form === t.form
        ) {
          return;
        }
        applyPriceFilter(root, t.form);
      },
      true
    );

    document.addEventListener(
      'submit',
      function (e) {
        var form = e.target;
        if (!(form instanceof HTMLFormElement)) return;
        var root = form.closest('[data-eg-ajax-filters]');
        if (!root) return;
        if (form.hasAttribute('data-eg-filter-form')) {
          e.preventDefault();
          fetchSection(root, paramsFromForm(form));
          return;
        }
        if (form.hasAttribute('data-eg-collection-sort-form')) {
          e.preventDefault();
          var desk = root.querySelector('form[data-eg-filter-form="desk"]');
          var mob = root.querySelector('form[data-eg-filter-form="mob"]');
          var f = mqDesk.matches && desk ? desk : mob || desk;
          var p = f ? paramsFromForm(f) : paramsFromForm(form);
          if (p) fetchSection(root, p);
        }
      },
      true
    );

    document.addEventListener(
      'click',
      function (e) {
        var a = e.target.closest
          ? e.target.closest('a.eg-filter-chip, a.eg-filter-clear, a.eg-quick-filter-link, .eg-pagination a')
          : null;
        if (!a || !a.href) return;
        var root = a.closest ? a.closest('[data-eg-ajax-filters]') : null;
        if (!root) return;
        if (e.metaKey || e.ctrlKey || e.shiftKey) return;
        e.preventDefault();
        var fromPagination = !!(a.closest && a.closest('.eg-pagination'));
        var sectionId = root.getAttribute('data-eg-section-id');
        try {
          var u = new URL(a.href, window.location.origin);
          if (u.pathname !== window.location.pathname) {
            window.location.href = a.href;
            return;
          }
          if (fromPagination) scrollCollectionResultsIntoView(sectionId);
          fetchSection(root, u.searchParams).then(function () {
            if (fromPagination) scrollCollectionResultsIntoView(sectionId);
          });
        } catch (err) {
          window.location.href = a.href;
        }
      },
      true
    );

    syncPriceForms();

    var ajaxRoot = getCollectionAjaxRoot();
    if (ajaxRoot) restoreCategorySelection(ajaxRoot);
  }

  var EG_COLLECTION_LAYOUT_KEY = 'eg-collection-layout';

  /**
   * Grid / list toggle for collection product grid; preference stored in localStorage.
   */
  function parseCategoryCountsBlob(blob) {
    var map = {};
    var parts = String(blob || '').trim().split('|');
    for (var i = 0; i < parts.length; i++) {
      var at = parts[i].lastIndexOf(':');
      if (at < 1) continue;
      var n = parseInt(parts[i].slice(at + 1), 10);
      if (isNaN(n)) continue;
      map[parts[i].slice(0, at)] = n;
    }
    return map;
  }

  function applyCategoryCounts(scope, map) {
    qsa('[data-eg-count-handle]', scope).forEach(function (el) {
      var handle = el.getAttribute('data-eg-count-handle');
      if (!Object.prototype.hasOwnProperty.call(map, handle)) return;
      var format = el.getAttribute('data-eg-count-format');
      el.textContent = format ? format.replace('__N__', map[handle]) : '(' + map[handle] + ')';
    });
  }

  function initCollectionDeferredCounts() {
    var root = qs('[data-eg-counts-url]');
    if (!root) return;
    var url = root.getAttribute('data-eg-counts-url');
    root.removeAttribute('data-eg-counts-url');
    if (!url) return;
    fetch(url, {
      credentials: 'same-origin',
      headers: { 'X-Requested-With': 'XMLHttpRequest', Accept: 'text/html' },
    })
      .then(function (r) {
        if (!r.ok) throw new Error('HTTP ' + r.status);
        return r.text();
      })
      .then(function (text) {
        var map = parseCategoryCountsBlob(text);
        if (!Object.keys(map).length) throw new Error('no counts parsed from response');
        applyCategoryCounts(root, map);
      })
      .catch(function (err) {
        console.warn(
          '[eg] category counts could not be refreshed; the page is showing unadjusted totals. ' +
            'Requested ' + url + ' — ' + ((err && err.message) || err)
        );
      });
  }

  function applyCollectionLayout(root) {
    var section = root || qs('[data-eg-collection-root]');
    if (!section) return;
    var grid = qs('[data-eg-collection-product-grid]', section);
    if (!grid) return;

    var fallback = section.getAttribute('data-eg-collection-layout-default') || 'grid';
    var stored = null;
    try {
      stored = window.localStorage.getItem(EG_COLLECTION_LAYOUT_KEY);
    } catch (err) {
      stored = null;
    }
    var mode = stored === 'list' || stored === 'grid' ? stored : fallback;

    if (mode === 'list') {
      grid.classList.add('eg-product-grid--list');
    } else {
      grid.classList.remove('eg-product-grid--list');
    }

    qsa('[data-eg-view-mode]', section).forEach(function (btn) {
      var m = btn.getAttribute('data-eg-view-mode');
      var on = (m === 'list' && mode === 'list') || (m === 'grid' && mode === 'grid');
      btn.classList.toggle('is-active', on);
      btn.setAttribute('aria-pressed', on ? 'true' : 'false');
    });
  }

  function initCollectionViewToggle() {
    if (initCollectionViewToggle.__bound) return;
    initCollectionViewToggle.__bound = true;

    window.__egApplyCollectionLayout = function () {
      applyCollectionLayout();
    };

    document.addEventListener('click', function (e) {
      var btn = e.target.closest ? e.target.closest('[data-eg-view-mode]') : null;
      if (!btn) return;
      var root = btn.closest('[data-eg-collection-root]');
      if (!root) return;
      e.preventDefault();
      var mode = btn.getAttribute('data-eg-view-mode');
      if (mode !== 'grid' && mode !== 'list') return;
      try {
        window.localStorage.setItem(EG_COLLECTION_LAYOUT_KEY, mode);
      } catch (err) {
        /* ignore */
      }
      applyCollectionLayout(root);
    });

    applyCollectionLayout();
  }

  function initFilterSheet() {
    if (initFilterSheet.__delegated) return;
    initFilterSheet.__delegated = true;

    var mqDesk = window.matchMedia(COLLECTION_FILTERS_MQ);

    function getCollectionRootFromButton(btn) {
      return btn && btn.closest ? btn.closest('[data-eg-collection-root]') : null;
    }

    document.addEventListener('click', function (e) {
      var openBtn = e.target.closest ? e.target.closest('[data-eg-open-filters]') : null;
      if (!openBtn) return;
      e.preventDefault();
      var root = getCollectionRootFromButton(openBtn);
      if (mqDesk.matches) {
        if (root) root.classList.toggle('eg-collection--filters-collapsed');
        syncCollectionFiltersToggle();
        return;
      }
      var sheet = collectionFilterSheet(root);
      if (!sheet || typeof sheet.showModal !== 'function') return;
      if (sheet.open) {
        sheet.close();
      } else {
        openCollectionFilterSheet(sheet);
      }
    });

    document.addEventListener('click', function (e) {
      var closeBtn = e.target.closest ? e.target.closest('[data-eg-close-filters]') : null;
      if (!closeBtn) return;
      e.preventDefault();
      closeCollectionFilterSheet(closeBtn.closest('[data-eg-filter-sheet]'));
    });

    // A modal <dialog> fills its own box only; a click landing on the element itself
    // is the backdrop area around the sheet.
    document.addEventListener('click', function (e) {
      if (!e.target.matches || !e.target.matches('[data-eg-filter-sheet]')) return;
      closeCollectionFilterSheet(e.target);
    });

    // Fires for the close button, Escape, and the backdrop alike.
    document.addEventListener(
      'close',
      function (e) {
        if (!e.target || !e.target.matches || !e.target.matches('[data-eg-filter-sheet]')) return;
        lockScroll(false);
        syncCollectionFiltersToggle();
      },
      true
    );

    function onBreakpointChange() {
      qsa('[data-eg-filter-sheet]').forEach(closeCollectionFilterSheet);
      if (!mqDesk.matches) {
        qsa('[data-eg-toggle-desktop-filters]').forEach(function (btn) {
          var r = getCollectionRootFromButton(btn);
          if (r) r.classList.remove('eg-collection--filters-collapsed');
        });
      }
      syncCollectionFiltersToggle();
    }

    if (mqDesk.addEventListener) mqDesk.addEventListener('change', onBreakpointChange);
    else if (mqDesk.addListener) mqDesk.addListener(onBreakpointChange);

    syncCollectionFiltersToggle();
  }

  function escapeHtml(s) {
    if (s == null || s === '') return '';
    var d = document.createElement('div');
    d.textContent = s;
    return d.innerHTML;
  }

  function firstAvailableVariantId(product) {
    var v = product.variants;
    if (!v || !v.length) return null;
    for (var i = 0; i < v.length; i++) {
      if (v[i].available) return v[i].id;
    }
    return v[0].id;
  }

  function productHasTag(product, tagName) {
    if (!product || !tagName) return false;
    var tags = product.tags;
    if (!tags || !tags.length) return false;
    var needle = String(tagName).trim().toLowerCase();
    for (var i = 0; i < tags.length; i++) {
      if (String(tags[i]).trim().toLowerCase() === needle) return true;
    }
    return false;
  }

  function appendQuoteProductParams(baseUrl, product) {
    var url = baseUrl || '/pages/request-a-quote';
    var handle = product && product.handle;
    if (!handle) return url;
    var sep = url.indexOf('?') >= 0 ? '&' : '?';
    var out = url + sep + 'add=' + encodeURIComponent(handle);
    var variantId = firstAvailableVariantId(product);
    if (variantId) out += '&variant=' + encodeURIComponent(String(variantId));
    return out;
  }

  function buildRecentMiniCard(product, opts) {
    var addLabel = (opts && opts.addLabel) || 'Add to cart';
    var quoteLabel = (opts && opts.quoteLabel) || 'Request a Quote';
    var quoteUrl = (opts && opts.quoteUrl) || '/pages/request-a-quote';
    var useQuotify = !!(opts && opts.useQuotify);
    var cartIconHtml = (opts && opts.cartIconHtml) || '';
    var packIconHtml = (opts && opts.packIconHtml) || '';
    var spinnerIconHtml = (opts && opts.spinnerIconHtml) || '';
    var ltlShippingOnly = productHasTag(product, 'ltl-shipping');
    var variantId = firstAvailableVariantId(product);
    var root = document.createElement('div');
    root.className = 'eg-mini-card';

    var link = document.createElement('a');
    link.className = 'eg-mini-card__link';
    link.href = product.url || '/products/' + encodeURIComponent(product.handle || '');

    var imgWrap = document.createElement('div');
    imgWrap.className = 'eg-mini-card__img';
    var src = product.featured_image;
    if (src) {
      if (src.indexOf('//') === 0) src = 'https:' + src;
      var img = document.createElement('img');
      img.src = src;
      img.loading = 'lazy';
      img.alt = product.title || '';
      img.width = 480;
      img.height = 480;
      imgWrap.appendChild(img);
    } else {
      var ph = document.createElement('div');
      ph.className = 'eg-mini-card__img-placeholder eg-bg-gradient-placeholder';
      ph.innerHTML = packIconHtml;
      imgWrap.appendChild(ph);
    }

    var body = document.createElement('div');
    body.className = 'eg-mini-card__body';
    var h3 = document.createElement('h3');
    h3.className = 'eg-mini-card__title';
    h3.textContent = product.title || '';
    body.appendChild(h3);

    // Show the price for all products, including ltl-shipping (quote) items; the
    // Request a Quote action below is kept separately for ltl-shipping products.
    var priceP = document.createElement('p');
    priceP.className = 'eg-mini-card__price';
    var cents =
      typeof product.price === 'number'
        ? product.price
        : parseInt(String(product.price != null ? product.price : ''), 10) || 0;
    priceP.textContent = formatMoney(cents);
    body.appendChild(priceP);

    link.appendChild(imgWrap);
    link.appendChild(body);

    var action;
    if (ltlShippingOnly) {
      if (useQuotify) {
        action = document.createElement('button');
        action.type = 'button';
        action.className = 'eg-mini-card__btn';
        action.setAttribute('data-quotify', '');
        action.setAttribute('data-eg-quote-quotify', '');
        if (product.id != null) action.setAttribute('data-product-id', String(product.id));
        if (variantId) action.setAttribute('data-variant', String(variantId));
        action.innerHTML = '<span class="eg-mini-card__btn-label">' + escapeHtml(quoteLabel) + '</span>';
      } else {
        action = document.createElement('a');
        action.className = 'eg-mini-card__btn';
        action.href = appendQuoteProductParams(quoteUrl, product);
        action.innerHTML = '<span class="eg-mini-card__btn-label">' + escapeHtml(quoteLabel) + '</span>';
      }
    } else {
      action = document.createElement('button');
      action.type = 'button';
      action.className = 'eg-mini-card__btn';
      if (variantId) {
        action.setAttribute('data-eg-quick-add', '');
        action.setAttribute('data-variant-id', String(variantId));
      } else {
        action.disabled = true;
      }
      action.innerHTML =
        '<span class="eg-mini-card__btn-icon" aria-hidden="true">' +
        cartIconHtml +
        '</span><span class="eg-mini-card__btn-spinner" aria-hidden="true">' +
        spinnerIconHtml +
        '</span><span class="eg-mini-card__btn-label">' +
        escapeHtml(addLabel) +
        '</span>';
    }

    root.appendChild(link);
    root.appendChild(action);
    return root;
  }

  function initRecentlyViewed() {
    var storageKey = 'eg_recent_handles';
    var track = qs('[data-eg-recent-track]');
    var handle = track && track.getAttribute('data-product-handle');

    try {
      var raw = window.localStorage.getItem(storageKey);
      var handles = raw ? JSON.parse(raw) : [];
      if (!Array.isArray(handles)) handles = [];
      if (handle) {
        handles = handles.filter(function (h) {
          return h !== handle;
        });
        handles.unshift(handle);
        handles = handles.filter(function (h, i, arr) {
          return h && arr.indexOf(h) === i;
        });
        handles = handles.slice(0, 12);
        window.localStorage.setItem(storageKey, JSON.stringify(handles));
      }
    } catch (e) {}

    var outlet = qs('[data-eg-recent-products-outlet]');
    if (!outlet) return;

    var section = outlet.closest('[data-eg-recently-viewed-section]');
    var limit = parseInt(outlet.getAttribute('data-limit') || '4', 10) || 4;
    var addLabel = outlet.getAttribute('data-add-label') || 'Add to cart';
    var quoteLabel = outlet.getAttribute('data-quote-label') || 'Request a Quote';
    var viewLabel = outlet.getAttribute('data-view-label') || 'View';
    var quoteUrl = outlet.getAttribute('data-quote-url') || '/pages/request-a-quote';
    var useQuotify = outlet.getAttribute('data-use-quotify') === 'true';
    var isB2b = outlet.getAttribute('data-customer-b2b') === 'true';
    var cartTpl = qs('[data-eg-recent-mini-cart-icon]');
    var packTpl = qs('[data-eg-recent-mini-package-icon]');
    var spinnerTpl = qs('[data-eg-recent-mini-spinner-icon]');
    var cartIconHtml = cartTpl ? cartTpl.innerHTML : '';
    var packIconHtml = packTpl ? packTpl.innerHTML : '';
    var spinnerIconHtml = spinnerTpl ? spinnerTpl.innerHTML : '';

    var current = handle || '';
    var toShow = [];
    try {
      raw = window.localStorage.getItem(storageKey);
      handles = raw ? JSON.parse(raw) : [];
      if (!Array.isArray(handles)) handles = [];
      toShow = handles
        .filter(function (h) {
          return h && h !== current;
        })
        .slice(0, limit);
    } catch (err) {
      toShow = [];
    }

    if (!toShow.length) {
      return;
    }

    Promise.all(
      toShow.map(function (h) {
        return fetchJSON('/products/' + encodeURIComponent(h) + '.js').catch(function () {
          return null;
        });
      })
    ).then(function (products) {
      var valid = products.filter(Boolean);
      if (!valid.length) {
        return;
      }
      outlet.innerHTML = '';
      valid.forEach(function (p) {
        outlet.appendChild(
          buildRecentMiniCard(p, {
            addLabel: addLabel,
            quoteLabel: quoteLabel,
            viewLabel: viewLabel,
            quoteUrl: quoteUrl,
            useQuotify: useQuotify,
            isB2b: isB2b,
            cartIconHtml: cartIconHtml,
            packIconHtml: packIconHtml,
            spinnerIconHtml: spinnerIconHtml,
          })
        );
      });
      if (section) section.removeAttribute('hidden');

      if (!outlet.getAttribute('data-eg-quick-add-bound')) {
        outlet.setAttribute('data-eg-quick-add-bound', 'true');
        outlet.addEventListener('click', function (e) {
          var btn = e.target.closest('[data-eg-quick-add]');
          if (!btn || btn.disabled) return;
          e.preventDefault();
          e.stopPropagation();
          runQuickAdd(btn);
        });
      }
    });
  }

  function setDialogLoadingState(btn, dlg, isLoading) {
    if (btn) {
      btn.classList.toggle('is-loading', isLoading);
      btn.setAttribute('aria-busy', isLoading ? 'true' : 'false');

      var quick = btn.querySelector('.eg-product-drawing-card__quick');
      if (quick) {
        if (!quick.dataset.originalHtml) {
          quick.dataset.originalHtml = quick.innerHTML;
        }
        quick.innerHTML = isLoading
          ? '<span class="eg-product-drawing-card__quick-loader" aria-hidden="true"></span>'
          : quick.dataset.originalHtml;
      }
    }

    if (dlg) {
      dlg.classList.toggle('is-loading', isLoading);
      if (isLoading) {
        if (!dlg.querySelector('.eg-dialog-loading')) {
          var loader = document.createElement('div');
          loader.className = 'eg-dialog-loading';
          loader.innerHTML = '<span class="eg-dialog-loading__spinner" aria-hidden="true"></span>';
          dlg.appendChild(loader);
        }
      } else {
        dlg.querySelector('.eg-dialog-loading')?.remove();
      }
    }
  }

  function pauseYouTubeInDialog(dlg) {
    if (!dlg) return;
    qsa('iframe.eg-drawing-dialog__frame--youtube', dlg).forEach(function (iframe) {
      try {
        if (iframe.contentWindow) {
          iframe.contentWindow.postMessage(
            JSON.stringify({ event: 'command', func: 'pauseVideo', args: [] }),
            'https://www.youtube.com'
          );
        }
      } catch (err) {}
    });
  }

  // iOS WebKit leaves PDF <iframe>s blank. Detect broadly (incl. desktop-site mode).
  function egNeedsPdfIframeFallback() {
    var ua = navigator.userAgent || '';
    if (/iPad|iPhone|iPod/i.test(ua)) return true;
    // iPadOS 13+ can report as Macintosh with touch
    if (navigator.platform === 'MacIntel' && navigator.maxTouchPoints > 1) return true;
    // "Request Desktop Website" on iPhone/iPad: Apple Safari + touch
    var vendor = navigator.vendor || '';
    if (
      /Apple/i.test(vendor) &&
      /Safari/i.test(ua) &&
      !/Chrome|CriOS|FxiOS|EdgiOS|OPiOS|Android/i.test(ua) &&
      navigator.maxTouchPoints > 0
    ) {
      return true;
    }
    return false;
  }

  function resolvePdfOpenUrl(iframe) {
    var fromData = iframe.getAttribute('data-eg-pdf-url');
    if (fromData) return fromData;
    var src = iframe.getAttribute('src') || '';
    if (!src) return '';
    var hashIdx = src.indexOf('#');
    if (hashIdx !== -1) src = src.slice(0, hashIdx);
    return src;
  }

  function openPdfInSafari(url) {
    if (!url) return false;
    // Prefer a real <a> click — more reliable than window.open on iOS Safari.
    // Do not set download — iOS needs a navigation so Safari's PDF viewer can open.
    var a = document.createElement('a');
    a.href = url;
    a.target = '_blank';
    a.rel = 'noopener noreferrer';
    document.body.appendChild(a);
    a.click();
    document.body.removeChild(a);
    return true;
  }

  function resolveDialogPdfUrl(dlg, btn) {
    if (btn) {
      var fromBtn = btn.getAttribute('data-eg-pdf-url');
      if (fromBtn) return fromBtn;
    }
    if (!dlg) return '';
    var fallback = qs('a.eg-drawing-dialog__ios-fallback', dlg);
    if (fallback && fallback.href) return fallback.href;
    var iframe = qs('iframe.eg-drawing-dialog__frame:not(.eg-drawing-dialog__frame--youtube)', dlg);
    if (iframe) return resolvePdfOpenUrl(iframe);
    var footerLink = qs('.eg-drawing-dialog__footer a[href]:not([href*="youtube"]):not([href*="youtu.be"])', dlg);
    if (footerLink && footerLink.href) return footerLink.getAttribute('href') || footerLink.href;
    return '';
  }

  function replaceIosPdfIframes(root) {
    if (!egNeedsPdfIframeFallback()) return;
    qsa('iframe.eg-drawing-dialog__frame:not(.eg-drawing-dialog__frame--youtube)', root || document).forEach(
      function (iframe) {
        if (iframe.getAttribute('data-eg-ios-pdf-replaced') === 'true') return;
        var url = resolvePdfOpenUrl(iframe);
        if (!url) return;

        var title = iframe.getAttribute('title') || '';
        var hint = iframe.getAttribute('data-eg-ios-open-label') || 'Tap to open the document';

        var link = document.createElement('a');
        link.className = 'eg-drawing-dialog__ios-fallback';
        link.href = url;
        link.target = '_blank';
        link.rel = 'noopener noreferrer';
        if (title) link.setAttribute('aria-label', title);

        if (title) {
          var titleEl = document.createElement('span');
          titleEl.className = 'eg-drawing-dialog__ios-fallback-title';
          titleEl.textContent = title;
          link.appendChild(titleEl);
        }

        var hintEl = document.createElement('span');
        hintEl.className = 'eg-drawing-dialog__ios-fallback-hint';
        hintEl.textContent = hint;
        link.appendChild(hintEl);

        iframe.setAttribute('data-eg-ios-pdf-replaced', 'true');
        iframe.removeAttribute('src');
        if (iframe.parentNode) {
          iframe.parentNode.replaceChild(link, iframe);
        }
      }
    );
  }

  function getOpenDrawingDialog() {
    return document.querySelector('dialog.eg-dialog[open], dialog.eg-drawing-dialog[open]');
  }

  function closeOpenDrawingDialog() {
    var dlg = getOpenDrawingDialog();
    if (!dlg || typeof dlg.close !== 'function') return false;
    dlg.close();
    return true;
  }

  // Return focus to the trigger so keyboard users keep their place (WCAG 2.4.3).
  // The visible ring is already scoped to :focus-visible in CSS, so mouse users see nothing.
  function restoreDialogOpenerFocus(dlg) {
    var opener = dlg && dlg.__egDialogOpener ? dlg.__egDialogOpener : null;
    if (dlg) dlg.__egDialogOpener = null;
    if (!opener || typeof opener.focus !== 'function') return;
    if (!document.contains(opener)) return;
    try {
      opener.focus({ preventScroll: true });
    } catch (err) {
      opener.focus();
    }
  }

  function initDialogTriggers() {
    replaceIosPdfIframes();

    qsa('[data-eg-open-dialog]').forEach(function (btn) {
      btn.addEventListener('click', function (e) {
        e.preventDefault();
        var id = btn.getAttribute('data-eg-open-dialog');
        var dlg = id ? document.getElementById(id) : null;
        if (!dlg || typeof dlg.showModal !== 'function') return;

        // iOS cannot show PDFs in iframes — open the file in Safari instead of a blank modal.
        if (egNeedsPdfIframeFallback()) {
          var pdfUrl = resolveDialogPdfUrl(dlg, btn);
          if (pdfUrl && openPdfInSafari(pdfUrl)) return;
        }

        replaceIosPdfIframes(dlg);
        dlg.__egDialogOpener = btn;
        setDialogLoadingState(btn, dlg, true);
        requestAnimationFrame(function () {
          dlg.showModal();
          // Keep focus in the dialog so Escape closes it (vs. being trapped in a YouTube iframe).
          var closeBtn = qs('[data-eg-close-dialog]', dlg);
          if (closeBtn && typeof closeBtn.focus === 'function') {
            try {
              closeBtn.focus({ preventScroll: true });
            } catch (errFocus) {
              closeBtn.focus();
            }
          } else if (typeof dlg.focus === 'function') {
            if (!dlg.hasAttribute('tabindex')) dlg.setAttribute('tabindex', '-1');
            try {
              dlg.focus({ preventScroll: true });
            } catch (errDlgFocus) {
              dlg.focus();
            }
          }
          window.setTimeout(function () {
            setDialogLoadingState(btn, dlg, false);
          }, 180);
        });
      });
    });
    qsa('[data-eg-close-dialog]').forEach(function (btn) {
      btn.addEventListener('click', function (e) {
        e.preventDefault();
        var dlg = btn.closest('dialog');
        if (dlg && typeof dlg.close === 'function') dlg.close();
      });
    });
    qsa('dialog.eg-drawing-dialog, dialog.eg-dialog').forEach(function (dlg) {
      if (dlg.getAttribute('data-eg-dialog-bound')) return;
      dlg.setAttribute('data-eg-dialog-bound', 'true');
      dlg.addEventListener('cancel', function (e) {
        // Ensure Escape always closes (and still fires the close → pause YouTube path).
        e.preventDefault();
        if (typeof dlg.close === 'function') dlg.close();
      });
      dlg.addEventListener('close', function () {
        pauseYouTubeInDialog(dlg);
        restoreDialogOpenerFocus(dlg);
      });
    });

    if (!initDialogTriggers.__escBound) {
      initDialogTriggers.__escBound = true;
      document.addEventListener(
        'keydown',
        function (e) {
          if (e.key !== 'Escape') return;
          if (!getOpenDrawingDialog()) return;
          e.preventDefault();
          closeOpenDrawingDialog();
        },
        true
      );
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }

  function initProductQtySteppers() {
    if (parseProductVariantPricing() && qs('[data-eg-price]')) return;
    var wrap = qs('.eg-product-form__qty');
    if (!wrap) return;
    var input = qs('[data-eg-qty-input]', wrap);
    var minus = qs('[data-eg-qty-minus]', wrap);
    var plus = qs('[data-eg-qty-plus]', wrap);
    if (!input || !minus || !plus) return;

    function syncMinusDisabled() {
      if (input.disabled) {
        minus.disabled = true;
        plus.disabled = true;
        return;
      }
      var v = parseInt(input.value, 10) || 1;
      minus.disabled = v <= 1;
    }

    minus.addEventListener('click', function () {
      var v = parseInt(input.value, 10) || 1;
      if (v > 1) input.value = String(v - 1);
      syncMinusDisabled();
    });
    plus.addEventListener('click', function () {
      var v = parseInt(input.value, 10) || 0;
      input.value = String(Math.max(1, v + 1));
      syncMinusDisabled();
    });
    input.addEventListener('input', function () {
      var v = parseInt(input.value, 10);
      if (isNaN(v) || v < 1) return;
      syncMinusDisabled();
    });
    input.addEventListener('change', function () {
      var v = parseInt(input.value, 10);
      if (isNaN(v) || v < 1) input.value = '1';
      syncMinusDisabled();
    });
    syncMinusDisabled();
  }

  function formatMoneyCents(cents) {
    if (typeof cents !== 'number' || isNaN(cents)) return '';
    if (typeof Shopify !== 'undefined' && typeof Shopify.formatMoney === 'function') {
      return Shopify.formatMoney(cents, getMoneyFormat());
    }
    return formatMoneyWithFormat(cents, getMoneyFormat());
  }

  function parseProductVariantPricing() {
    var el = qs('#eg-product-variant-pricing');
    if (!el) return null;
    try {
      return JSON.parse(el.textContent);
    } catch (e) {
      return null;
    }
  }

  function unitPriceForQuantity(variant, qty) {
    if (!variant) return 0;
    var price = Number(variant.price);
    if (isNaN(price)) return 0;
    var breaks = variant.quantityPriceBreaks;
    if (!breaks || !breaks.length) return price;
    var sorted = breaks.slice().sort(function (a, b) {
      return Number(b.minimumQuantity) - Number(a.minimumQuantity);
    });
    for (var i = 0; i < sorted.length; i++) {
      var minQty = Number(sorted[i].minimumQuantity);
      var breakPrice = Number(sorted[i].price);
      if (!isNaN(minQty) && !isNaN(breakPrice) && qty >= minQty) return breakPrice;
    }
    return price;
  }

  function renderPdpPriceHtml(unitCents, compareCents, isB2b, badgeTemplate) {
    var showCompare = compareCents != null && compareCents > unitCents;
    if (!showCompare) {
      return '<span>' + formatMoneyCents(unitCents) + '</span>';
    }
    var pct = Math.round(((compareCents - unitCents) * 100) / compareCents);
    var badgeHtml = '';
    if (isB2b && pct > 0 && badgeTemplate) {
      badgeHtml = '<span class="eg-b2b-price__badge">' + badgeTemplate.replace('__P__', String(pct)) + '</span>';
    }
    return (
      '<span class="eg-price-compare">' +
      formatMoneyCents(compareCents) +
      '</span><span class="eg-price-sale">' +
      formatMoneyCents(unitCents) +
      '</span>' +
      badgeHtml
    );
  }

  function initProductPdpPricing() {
    var pricingData = parseProductVariantPricing();
    var priceEl = qs('[data-eg-price]');
    if (!pricingData || !priceEl) return;

    var sel = qs('[data-eg-variant-select]');
    var idInput = qs('.eg-product-form input[name="id"]');
    var qtyInput = qs('[data-eg-qty-input]');
    var submitBtn = qs('.eg-product-form__submit');
    var skuEl = qs('[data-eg-variant-sku]');
    var stockEl = qs('.eg-stock');
    var stockSep = qs('[data-eg-stock-separator]');
    var variantMap = Object.create(null);
    pricingData.variants.forEach(function (v) {
      variantMap[String(v.id)] = v;
    });

    function currentQty() {
      if (!qtyInput) return 1;
      var q = parseInt(qtyInput.value, 10);
      return !q || q < 1 ? 1 : q;
    }

    function activeVariantId() {
      if (sel) return sel.value;
      if (idInput) return idInput.value;
      return String(pricingData.initialVariantId);
    }

    function updatePriceDisplay() {
      var variant = variantMap[activeVariantId()];
      if (!variant) return;
      // Always show the unit price. Quantity only affects the cart subtotal,
      // never the price shown on the PDP.
      var unitCents = unitPriceForQuantity(variant, currentQty());
      var compareUnit = variant.compareAtPrice != null ? variant.compareAtPrice : null;
      var discounted = compareUnit != null && compareUnit > unitCents;
      priceEl.classList.toggle('eg-product__price--discounted', discounted);
      priceEl.innerHTML = renderPdpPriceHtml(
        unitCents,
        compareUnit,
        pricingData.isB2b,
        pricingData.badgeTemplate
      );
    }

    function syncQtySteppers() {
      if (!qtyInput) return;
      var minus = qs('[data-eg-qty-minus]');
      var plus = qs('[data-eg-qty-plus]');
      var v = currentQty();
      if (qtyInput.disabled) {
        if (minus) minus.disabled = true;
        if (plus) plus.disabled = true;
        return;
      }
      if (minus) minus.disabled = v <= 1;
      if (plus) plus.disabled = false;
    }

    function bindQtySteppers() {
      if (!qtyInput) return;
      var minus = qs('[data-eg-qty-minus]');
      var plus = qs('[data-eg-qty-plus]');

      function onQtyChange() {
        syncQtySteppers();
        updatePriceDisplay();
      }

      if (minus) {
        minus.addEventListener('click', function () {
          var v = currentQty();
          if (v > 1) qtyInput.value = String(v - 1);
          onQtyChange();
        });
      }
      if (plus) {
        plus.addEventListener('click', function () {
          qtyInput.value = String(currentQty() + 1);
          onQtyChange();
        });
      }
      qtyInput.addEventListener('input', onQtyChange);
      qtyInput.addEventListener('change', function () {
        var v = parseInt(qtyInput.value, 10);
        if (isNaN(v) || v < 1) qtyInput.value = '1';
        onQtyChange();
      });
      syncQtySteppers();
    }

    function renderVolumePricing(variantId) {
      var wrap = qs('[data-eg-volume-pricing]');
      if (!wrap) return;
      var tbody = qs('[data-eg-volume-rows]', wrap);
      var variant = variantMap[String(variantId)];
      if (!tbody || !variant) return;

      var breaks = (variant.quantityPriceBreaks || []).slice().sort(function (a, b) {
        return a.minimumQuantity - b.minimumQuantity;
      });
      if (!breaks.length) {
        wrap.hidden = true;
        return;
      }
      wrap.hidden = false;

      var showSavings = wrap.getAttribute('data-show-savings') === 'true';
      var rangeTpl = wrap.getAttribute('data-range-template') || '__MIN__ - __MAX__';
      var minTpl = wrap.getAttribute('data-minimum-template') || '__QTY__+';
      var saveTpl = wrap.getAttribute('data-save-template') || 'Save __P__%';

      function range(min, max) {
        return rangeTpl.replace('__MIN__', min).replace('__MAX__', max);
      }
      function row(label, cents, save) {
        var cells = '<td>' + escapeHtml(label) + '</td><td>' + formatMoneyCents(cents) + '</td>';
        if (showSavings) {
          cells += '<td>' + (save > 0 ? escapeHtml(saveTpl.replace('__P__', save)) : '') + '</td>';
        }
        return '<tr>' + cells + '</tr>';
      }

      var html = [row(range(1, breaks[0].minimumQuantity - 1), variant.price, 0)];
      breaks.forEach(function (qb, i) {
        var label =
          i === breaks.length - 1
            ? minTpl.replace('__QTY__', qb.minimumQuantity)
            : range(qb.minimumQuantity, breaks[i + 1].minimumQuantity - 1);
        html.push(row(label, qb.price, Math.floor(((variant.price - qb.price) * 100) / variant.price)));
      });
      tbody.innerHTML = html.join('');
    }

    function setVariantSelected(variantId) {
      var variant = variantMap[variantId];
      if (!variant) return;
      renderVolumePricing(variantId);
      if (sel) sel.value = variantId;
      if (idInput) idInput.value = variantId;
      qsa('[data-eg-variant-btn]').forEach(function (btn) {
        var vid = btn.getAttribute('data-eg-variant-btn');
        var on = String(vid) === String(variantId);
        btn.classList.toggle('eg-variant-btn--selected', on);
        btn.setAttribute('aria-checked', on ? 'true' : 'false');
        btn.setAttribute('tabindex', on ? '0' : '-1');
      });
      if (typeof history !== 'undefined' && history.replaceState) {
        var url = new URL(window.location.href);
        url.searchParams.set('variant', variantId);
        history.replaceState({}, '', url.toString());
      }
      qsa('[data-eg-quote-quotify]').forEach(function (btn) {
        btn.setAttribute('data-variant', String(variantId));
      });
      qsa('[data-eg-quote-link]').forEach(function (link) {
        var href = link.getAttribute('href');
        if (!href) return;
        var parts = href.split('?');
        var params = new URLSearchParams(parts[1] || '');
        params.set('variant', variantId);
        link.setAttribute('href', parts[0] + '?' + params.toString());
      });
      if (skuEl) {
        if (variant.sku) {
          skuEl.textContent = 'SKU: ' + variant.sku;
          skuEl.hidden = false;
        } else {
          skuEl.textContent = '';
          skuEl.hidden = true;
        }
      }
      if (submitBtn) {
        submitBtn.disabled = !variant.available;
        var label = qs('.eg-product-form__submit-label', submitBtn);
        if (label) {
          label.textContent = variant.available
            ? submitBtn.getAttribute('data-label-available') || label.textContent
            : submitBtn.getAttribute('data-label-sold-out') || label.textContent;
        }
      }
      if (qtyInput) {
        qtyInput.disabled = !variant.available;
      }
      if (stockEl) {
        stockEl.hidden = !variant.available;
      }
      if (stockSep) {
        stockSep.hidden = !variant.available;
      }
      syncQtySteppers();
      updatePriceDisplay();
      if (egProductGallery && variant.featuredMediaId) {
        egProductGallery.setActiveMedia(variant.featuredMediaId);
      }
    }

    qsa('[data-eg-variant-btn]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var vid = btn.getAttribute('data-eg-variant-btn');
        if (!vid || String(activeVariantId()) === vid) return;
        setVariantSelected(vid);
      });
    });
    bindVariantRadioGroup(function (vid) {
      if (!vid || String(activeVariantId()) === vid) return;
      setVariantSelected(vid);
    });
    if (sel) {
      sel.addEventListener('change', function () {
        setVariantSelected(sel.value);
      });
    }
    bindQtySteppers();

    var productForm = qs('.eg-product-form');
    if (productForm) {
      productForm.addEventListener('input', function (e) {
        if (e.target && e.target.matches('[data-eg-qty-input]')) updatePriceDisplay();
      });
      productForm.addEventListener('click', function (e) {
        if (e.target && e.target.closest('[data-eg-qty-minus], [data-eg-qty-plus]')) {
          window.setTimeout(updatePriceDisplay, 0);
        }
      });
    }
  }

  /**
   * Roving tabindex + arrow keys for the variant buttons, which carry role="radio".
   * Pass onSelect to select on arrow (cheap, in-page). Omit it where selecting navigates,
   * so arrows only move focus and Enter/Space commits via the button's own click handler.
   */
  function bindVariantRadioGroup(onSelect) {
    var buttons = qsa('[data-eg-variant-btn]');
    if (buttons.length < 2) return;

    function moveTo(index) {
      var btn = buttons[index];
      if (!btn) return;
      buttons.forEach(function (other) {
        other.setAttribute('tabindex', other === btn ? '0' : '-1');
      });
      btn.focus();
      if (onSelect) onSelect(btn.getAttribute('data-eg-variant-btn'));
    }

    buttons.forEach(function (btn, index) {
      btn.addEventListener('keydown', function (e) {
        var last = buttons.length - 1;
        var target;
        switch (e.key) {
          case 'ArrowRight':
          case 'ArrowDown':
            target = index === last ? 0 : index + 1;
            break;
          case 'ArrowLeft':
          case 'ArrowUp':
            target = index === 0 ? last : index - 1;
            break;
          case 'Home':
            target = 0;
            break;
          case 'End':
            target = last;
            break;
          default:
            return;
        }
        e.preventDefault();
        moveTo(target);
      });
    });
  }

  function initProductVariantSelect() {
    if (qs('#eg-product-variant-pricing')) return;
    var sel = qs('[data-eg-variant-select]');
    if (!sel) return;
    sel.addEventListener('change', function () {
      var url = new URL(window.location.href);
      url.searchParams.set('variant', sel.value);
      window.location.href = url.toString();
    });
    qsa('[data-eg-variant-btn]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var vid = btn.getAttribute('data-eg-variant-btn');
        if (!vid || String(sel.value) === vid) return;
        sel.value = vid;
        sel.dispatchEvent(new Event('change', { bubbles: true }));
      });
    });
    bindVariantRadioGroup();
  }

  function closeMegaMenu(returnFocus) {
    var details = qs('details[data-eg-mega]');
    if (!details || !details.open) return;
    var summary = qs('summary', details);
    var focusWasInside = details.contains(document.activeElement);
    details.open = false;
    if (returnFocus && focusWasInside && summary) summary.focus();
  }

  function initMegaMenu() {
    var details = qs('details[data-eg-mega]');
    if (!details) return;
    if (details.dataset.egMegaInit === '1') return;
    details.dataset.egMegaInit = '1';

    var closeTimer;
    var delay = 220;

    var summary = qs('summary[data-eg-mega-url]', details);
    if (summary) {
      summary.addEventListener('click', function (e) {
        if (e.detail === 0) return;
        var url = summary.getAttribute('data-eg-mega-url');
        if (!url) return;
        e.preventDefault();
        if (e.metaKey || e.ctrlKey || e.shiftKey) window.open(url, '_blank');
        else window.location.assign(url);
      });
    }

    function openMenu() {
      window.clearTimeout(closeTimer);
      details.open = true;
    }

    function scheduleClose() {
      window.clearTimeout(closeTimer);
      closeTimer = window.setTimeout(function () {
        details.open = false;
      }, delay);
    }

    function onFocusOut(e) {
      var rt = e.relatedTarget;
      if (rt && details.contains(rt)) return;
      scheduleClose();
    }

    function bind() {
      details.addEventListener('mouseenter', openMenu);
      details.addEventListener('mouseleave', scheduleClose);
      details.addEventListener('focusin', openMenu);
      details.addEventListener('focusout', onFocusOut);
    }

    function unbind() {
      details.removeEventListener('mouseenter', openMenu);
      details.removeEventListener('mouseleave', scheduleClose);
      details.removeEventListener('focusin', openMenu);
      details.removeEventListener('focusout', onFocusOut);
      window.clearTimeout(closeTimer);
    }

    var mq = window.matchMedia('(min-width: 1200px)');
    function applyMq() {
      unbind();
      details.open = false;
      if (mq.matches) bind();
    }
    applyMq();
    if (mq.addEventListener) {
      mq.addEventListener('change', applyMq);
    } else if (mq.addListener) {
      mq.addListener(applyMq);
    }
  }

  /** Tech docs library: one category open at a time (click/tap only). */
  function initTechLibraryAccordion() {
    document.querySelectorAll('.eg-tech-library').forEach(function (root) {
      var items = root.querySelectorAll('details.eg-tech-library__category');
      if (!items.length) return;

      items.forEach(function (d) {
        d.addEventListener('toggle', function () {
          if (!d.open) return;
          items.forEach(function (other) {
            if (other !== d) other.removeAttribute('open');
          });
        });
      });
    });
  }

  /**
   * Tech docs: move the open panel after the .eg-tech-library__row that contains
   * that card (directly under that row), not below the whole folder grid.
   */
  function initTechLibraryPanelBleed() {
    document.querySelectorAll('.eg-tech-docs-library').forEach(function (section) {
      var library = section.querySelector('.eg-tech-library');
      if (!library || !library.parentNode) return;

      section.querySelectorAll('details.eg-tech-library__category').forEach(function (d) {
        var shell = d.querySelector('[data-eg-tech-library-panel-shell]');
        if (!shell) return;

        // Number of grid columns for a row, from its computed template.
        function rowColumnCount(row) {
          if (!row) return 1;
          var tpl = getComputedStyle(row).gridTemplateColumns || '';
          if (!tpl || tpl === 'none') return 1;
          return tpl.split(' ').filter(function (t) { return t.trim() !== ''; }).length || 1;
        }

        d.addEventListener('toggle', function () {
          if (d.open) {
            var row = d.closest('.eg-tech-library__row');
            // Only "bleed" the panel to a full-width strip below the row when the grid
            // is multi-column. On a single-column (mobile) layout the cards are stacked,
            // so moving the panel after the row drops it below the whole group instead of
            // under the tapped card — keep it inside <details> there.
            if (rowColumnCount(row) > 1 && row && row.parentNode === library) {
              library.insertBefore(shell, row.nextSibling);
            } else if (shell.parentNode !== d) {
              d.appendChild(shell);
            }
          } else {
            d.appendChild(shell);
          }
        });
      });
    });
  }

  /**
   * Tech docs library: open the correct <details> when arriving with #tech-doc-cat-* or #tech-doc-sub-*
   * (e.g. from search). Subfolders require the parent category to be opened first.
   */
  function openTechLibraryFromHash() {
    var raw = window.location.hash || '';
    if (raw.charAt(0) !== '#') return;
    var id = raw.slice(1);
    if (!id || (id.indexOf('tech-doc-cat-') !== 0 && id.indexOf('tech-doc-sub-') !== 0)) return;

    var el = document.getElementById(id);
    if (!el || !el.closest('.eg-tech-library')) return;

    if (el.classList.contains('eg-tech-library__sub')) {
      var cat = el.closest('details.eg-tech-library__category');
      if (cat) cat.open = true;
      el.open = true;
    } else if (el.classList.contains('eg-tech-library__category')) {
      el.open = true;
    }

    window.requestAnimationFrame(function () {
      window.requestAnimationFrame(function () {
        el.scrollIntoView({ behavior: 'smooth', block: 'start' });
      });
    });
  }

  function initTechLibraryDeepLink() {
    if (!document.querySelector('.eg-tech-docs-library')) return;
    openTechLibraryFromHash();
    window.addEventListener('hashchange', openTechLibraryFromHash);
  }

  /** Sticky offsets: header bar (always) + announcement (scrolls away, used for mega at page top). */
  var lastHeaderHeight = -1;
  var lastAnnouncementHeight = -1;

  function syncHeaderHeightCssVar() {
    var root = document.documentElement;
    var headerBar = qs('.eg-header');
    var headerHeight = headerBar ? headerBar.offsetHeight : 0;
    if (headerHeight <= 0) {
      headerHeight = 80;
    }

    var announcementHeight = 0;
    var announcementSection = qs('.shopify-section.eg-section-announcement');
    if (announcementSection) {
      var ann = announcementSection.querySelector('.eg-announcement:not([hidden])');
      if (ann) {
        var annRect = announcementSection.getBoundingClientRect();
        if (annRect.bottom > 0) {
          announcementHeight = ann.offsetHeight;
        }
      }
    }

    if (headerHeight === lastHeaderHeight && announcementHeight === lastAnnouncementHeight) return;
    lastHeaderHeight = headerHeight;
    lastAnnouncementHeight = announcementHeight;

    root.style.setProperty('--eg-header-height', headerHeight + 'px');
    root.style.setProperty('--eg-announcement-height', announcementHeight + 'px');
    root.style.setProperty('--eg-header-bar-height', headerHeight + announcementHeight + 'px');
  }

  var headerSyncQueued = false;
  function queueHeaderHeightSync() {
    if (headerSyncQueued) return;
    headerSyncQueued = true;
    window.requestAnimationFrame(function () {
      headerSyncQueued = false;
      syncHeaderHeightCssVar();
    });
  }

  function initStickyHeaderHeightObserver() {
    syncHeaderHeightCssVar();
    var headerBar = qs('.eg-header');
    if (headerBar && typeof ResizeObserver !== 'undefined') {
      var ro = new ResizeObserver(queueHeaderHeightSync);
      ro.observe(headerBar);
      var announcement = qs('.eg-announcement');
      if (announcement) ro.observe(announcement);
    }
    window.addEventListener('scroll', queueHeaderHeightSync, { passive: true });
  }

  function initAnnouncementCarousel() {
    qsa('[data-eg-announcement-carousel]').forEach(function (bar) {
      if (bar.dataset.egAnnouncementCarouselInit === '1') return;
      bar.dataset.egAnnouncementCarouselInit = '1';

      var slides = qsa('[data-eg-announcement-slide]', bar);
      if (slides.length <= 1) return;

      var index = 0;
      var reducedMotion =
        window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      var autoplay = bar.getAttribute('data-autoplay') !== 'false' && !reducedMotion;
      var interval = parseInt(bar.getAttribute('data-autoplay-interval'), 10) || 5000;
      var timer = null;
      var viewport = qs('[data-eg-announcement-viewport]', bar);

      function setLiveRegion(on) {
        if (viewport) viewport.setAttribute('aria-live', on ? 'polite' : 'off');
      }

      function show(nextIndex) {
        index = (nextIndex + slides.length) % slides.length;
        slides.forEach(function (slide, i) {
          var active = i === index;
          slide.classList.toggle('is-active', active);
          slide.hidden = !active;
        });
        syncHeaderHeightCssVar();
      }

      function next() {
        show(index + 1);
      }

      function prev() {
        show(index - 1);
      }

      function stopAutoplay() {
        if (timer) {
          clearInterval(timer);
          timer = null;
        }
      }

      function startAutoplay() {
        stopAutoplay();
        if (!autoplay || bar.hidden) return;
        timer = setInterval(next, interval);
      }

      var prevBtn = qs('[data-eg-announcement-prev]', bar);
      var nextBtn = qs('[data-eg-announcement-next]', bar);
      var toggleBtn = qs('[data-eg-announcement-toggle]', bar);

      function syncToggleBtn() {
        if (!toggleBtn) return;
        var label = toggleBtn.getAttribute(autoplay ? 'data-label-pause' : 'data-label-play');
        if (label) toggleBtn.setAttribute('aria-label', label);
        var pauseIcon = qs('[data-eg-announcement-icon-pause]', toggleBtn);
        var playIcon = qs('[data-eg-announcement-icon-play]', toggleBtn);
        if (pauseIcon) pauseIcon.hidden = !autoplay;
        if (playIcon) playIcon.hidden = autoplay;
      }

      if (prevBtn) {
        prevBtn.addEventListener('click', function () {
          prev();
          startAutoplay();
        });
      }
      if (nextBtn) {
        nextBtn.addEventListener('click', function () {
          next();
          startAutoplay();
        });
      }
      if (toggleBtn) {
        toggleBtn.addEventListener('click', function () {
          autoplay = !autoplay;
          setLiveRegion(!autoplay);
          syncToggleBtn();
          startAutoplay();
        });
      }

      bar.addEventListener('mouseenter', stopAutoplay);
      bar.addEventListener('mouseleave', startAutoplay);
      bar.addEventListener('focusin', stopAutoplay);
      bar.addEventListener('focusout', function (e) {
        if (!bar.contains(e.relatedTarget)) startAutoplay();
      });

      show(0);
      setLiveRegion(!autoplay);
      syncToggleBtn();
      startAutoplay();
    });
  }

  function initAnnouncementBar() {
    var bar = qs('[data-eg-announcement]');
    if (!bar) return;
    var key = 'eg-announcement-dismissed';
    if (window.sessionStorage.getItem(key) === '1') {
      bar.hidden = true;
      syncHeaderHeightCssVar();
      return;
    }
    var closeBtn = qs('[data-eg-dismiss-announcement]', bar);
    if (!closeBtn) return;
    closeBtn.addEventListener('click', function () {
      bar.hidden = true;
      try {
        window.sessionStorage.setItem(key, '1');
      } catch (e) {}
      syncHeaderHeightCssVar();
    });
  }

  function initHeader() {
    initHeaderGlobalListeners();
    initSearchToggle();
    initPredictiveSearch();
    initMobileMenu();
    initMegaMenu();
  }

  /**
   * Menu links with href #request-quote → open Quotify (no product context).
   * Puts data-quotify-cart on the real link so Quotify receives the trusted click.
   */
  function initQuotifyMenuLinks() {
    if (initQuotifyMenuLinks.__bound) return;
    initQuotifyMenuLinks.__bound = true;
    var shopId = document.documentElement.getAttribute('data-eg-quotify-shop-id') || '';

    function isRequestQuoteHashLink(href) {
      if (!href || href.indexOf('javascript:') === 0) return false;
      try {
        return new URL(href, window.location.href).hash.toLowerCase() === '#request-quote';
      } catch (err) {
        return String(href).toLowerCase().indexOf('#request-quote') !== -1;
      }
    }

    function markQuoteMenuLink(a) {
      if (!a || a.hasAttribute('data-eg-quotify-menu-trigger')) return;
      a.setAttribute('data-eg-quotify-menu-trigger', '');
      a.setAttribute('data-quotify-cart', '');
      if (shopId) a.setAttribute('data-shop', shopId);
      a.setAttribute('href', '#request-quote');
      a.setAttribute('role', 'button');
    }

    function retargetQuoteMenuLinks(scope) {
      var rootEl = scope && scope.querySelectorAll ? scope : document;
      qsa('a[href]', rootEl).forEach(function (a) {
        if (!isRequestQuoteHashLink(a.getAttribute('href'))) return;
        markQuoteMenuLink(a);
      });
    }

    retargetQuoteMenuLinks(document);

    document.addEventListener(
      'click',
      function (e) {
        var a = e.target.closest ? e.target.closest('a[data-eg-quotify-menu-trigger], a[href]') : null;
        if (!a) return;
        var isTrigger = a.hasAttribute('data-eg-quotify-menu-trigger');
        var isQuoteHref = !isTrigger && isRequestQuoteHashLink(a.getAttribute('href'));
        if (!isTrigger && !isQuoteHref) return;
        if (isQuoteHref) markQuoteMenuLink(a);
        // Block hash jump; do not stopPropagation so Quotify can open.
        e.preventDefault();
      },
      true
    );

    document.addEventListener('shopify:section:load', function (e) {
      retargetQuoteMenuLinks(e.target || document);
    });
  }

  function boot() {
    initStickyHeaderHeightObserver();
    window.addEventListener('resize', queueHeaderHeightSync, { passive: true });
    window.addEventListener('load', queueHeaderHeightSync, { passive: true });

    stripProductSubmitIcons();
    refreshCartBadge();
    initCartDrawer();
    initCartPage();
    initAjaxAddToCart();
    initProductGallery();
    initProductPdpPricing();
    initProductVariantSelect();
    initProductQtySteppers();
    initHeader();
    initQuotifyMenuLinks();
    initCollectionNavCheckboxes();
    initCollectionAjaxFilters();
    initCollectionDeferredCounts();
    initFilterSheet();
    initCollectionViewToggle();
    initRecentlyViewed();
    initDialogTriggers();
    initTechLibraryAccordion();
    initTechLibraryPanelBleed();
    initTechLibraryDeepLink();
    initAnnouncementBar();
    initAnnouncementCarousel();
  }

  document.addEventListener('shopify:section:load', function () {
    initHeader();
    initAnnouncementBar();
    initAnnouncementCarousel();
    syncHeaderHeightCssVar();
    replaceIosPdfIframes();
  });
})();
